import { Button, Checkbox, Dialog, DialogActions, IconButton, InputAdornment, MenuItem, Stack, Switch, TextField, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import { useRef } from 'react';
import { useTheme } from '@emotion/react';
import { useDispatch } from 'react-redux';
import { TimePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import EventIcon from '@mui/icons-material/Event';
import FormSelectField from '../../../../components/FormSelectField';
import { Form, Formik } from 'formik';
import { buttonStyle2, dialogButtonCancel } from '../../../../utils/commonStyle';
import FormTextField from '../../../../components/FormTextField';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ChooseMeasurementValue from '../../../../components/ChooseMeasurementValue';
import FileUploadField from '../../../../components/FileUploadField/FileUploadField';
import DoneIcon from '@mui/icons-material/Done';
import * as yup from 'yup';
import { setLoading } from '../../../../redux/features/appSlice';
import { showmessage } from '../../../../utils/toastr';
import appapi from '../../../../api/apiClient';
import moment from 'moment';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import dayjs from 'dayjs';
import uploadFileToS3 from '../../../../utils/fileUpload';
import PortDropDown from '../../../../components/PortDropDown';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CancelToken } from 'apisauce';
import { TroubleshootRounded } from '@mui/icons-material';
import ActivityIndicator from '../../../../components/DataTable/ActivityIndicator';
import utc from 'dayjs/plugin/utc';

const validationSchema = yup.object({
  longitude: yup.number('Longitude').required(' '),
  latitude: yup.number('Latitude').required(' '),
  reportDate: yup.string('Report Date and Time').required(' '),
  voyageStatus: yup.string('Voyage Status').required(' '),
  // fuelUsed: yup
  //   .array()
  //   .of(
  //     yup.object().shape({
  //       efc: yup.number().required(),
  //     }),
  //   )
  //   .min(1)
  //   .required(),
});

const shipCondition = [
  {
    id: 1,
    name: 'laden',
  },
  {
    id: 2,
    name: 'ballast',
  },
  {
    id: 3,
    name: 'partladen',
  },
];

const sx = {
  '& .MuiDialog-container': {
    alignItems: 'center',
    WebkitAlignItems: 'center',
    WebkitBoxAlign: 'center',
  },
  '& .MuiPaper-root': {
    width: '100%',
    margin: '8px',
    borderRadius: '4px',
    // maxWidth: '736px',
    height: '100%',
    maxWidth: '100%',
    maxHeight: '90%',
  },
};

export default function AddNoonReport({ modelOpen, onModelHandleClose, voyageDetails, data, loading }) {
  const formRef = useRef();
  const theme = useTheme();
  const dispatch = useDispatch();

  let source = CancelToken.source();
  let source2 = CancelToken.source();

  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;

  const [sfocUnit, setSfocUnit] = useState('g/kwh');
  const [calorificUnit, setCalorific] = useState('kcal/kg');
  const [initReportDetails, setDetails] = useState([]);
  const [voyageStatus, setStates] = useState([]);

  const { t } = useTranslation();

  dayjs.extend(utc);

  const handleFile = (file) => {
    if (file?.path) {
      formRef?.current?.setFieldValue('bunkered.bunkeredDeliveryNote', file);
    } else {
      formRef?.current?.setFieldValue('bunkered.bunkeredDeliveryNote', undefined);
    }
  };

  const handleFile2 = (file) => {
    if (file?.path) {
      formRef?.current?.setFieldValue('cargo.billOfLoading', file);
    } else {
      formRef?.current?.setFieldValue('cargo.billOfLoading', undefined);
    }
  };

  const robCheck = (values) => {
    if (
      values?.remaingOnBoard?.hsfo ||
      values?.remaingOnBoard?.hsfo === 0 ||
      values?.remaingOnBoard?.mdo ||
      values?.remaingOnBoard?.mdo === 0 ||
      values?.remaingOnBoard?.mgo ||
      values?.remaingOnBoard?.mgo === 0 ||
      values?.remaingOnBoard?.lfo ||
      values?.remaingOnBoard?.lfo === 0 ||
      values?.remaingOnBoard?.lpgPropane ||
      values?.remaingOnBoard?.lpgPropane === 0 ||
      values?.remaingOnBoard?.lpgButane ||
      values?.remaingOnBoard?.lpgButane === 0 ||
      values?.remaingOnBoard?.lng ||
      values?.remaingOnBoard?.lng === 0 ||
      values?.remaingOnBoard?.methanol ||
      values?.remaingOnBoard?.methanol === 0 ||
      values?.remaingOnBoard?.ethanol ||
      values?.remaingOnBoard?.ethanol === 0 ||
      values?.remaingOnBoard?.others ||
      values?.remaingOnBoard?.others === 0
    ) {
      return true;
    }
    return false;
  };

  const cargoCheck = (values) => {
    if (values?.cargo?.loadingCondition && values?.cargo?.cargoCarried) {
      return true;
    }
    return false;
  };

  const portCheck = (values) => {
    if (values?.portInformation?.portName) {
      return true;
    }
    return false;
  };

  const voyageStateCheck = (values) => {
    if ((values?.voyageState?.sfoc || values?.voyageState?.sfoc === 0) && (values?.voyageState?.hours || values?.voyageState?.hours == 0 || values?.voyageState?.minutes || values?.voyageState?.minutes == 0)) {
      return true;
    }
    return false;
  };

  const distanceAndTimeCheck = (values) => {
    if (!values?.lastReportDistanceAndTime?.isTimeStamp && (values?.lastReportDistanceAndTime?.hours || values?.lastReportDistanceAndTime?.hours == 0 || values?.lastReportDistanceAndTime?.minutes || values?.lastReportDistanceAndTime?.minutes == 0) && (values?.lastReportDistanceAndTime?.distance || values?.lastReportDistanceAndTime?.distance === 0)) {
      return true;
    }
    if (values?.lastReportDistanceAndTime?.isTimeStamp && (values?.lastReportDistanceAndTime?.distance || values?.lastReportDistanceAndTime?.distance === 0)) {
      return true;
    }
    return false;
  };

  const bunkeredDataCheck = (values) => {
    if ((values?.bunkered?.hsfo?.mass || values?.bunkered?.hsfo?.mass === 0) && (values?.bunkered?.hsfo?.volume || values?.bunkered?.hsfo?.volume === 0) && (values?.bunkered?.hsfo?.density || values?.bunkered?.hsfo?.density === 0)) {
      return true;
    }
    if ((values?.bunkered?.mdo?.mass || values?.bunkered?.mdo?.mass === 0) && (values?.bunkered?.mdo?.volume || values?.bunkered?.mdo?.volume === 0) && (values?.bunkered?.mdo?.density || values?.bunkered?.mdo?.density === 0)) {
      return true;
    }
    if ((values?.bunkered?.mgo?.mass || values?.bunkered?.mgo?.mass === 0) && (values?.bunkered?.mgo?.volume || values?.bunkered?.mgo?.volume === 0) && (values?.bunkered?.mgo?.density || values?.bunkered?.mgo?.density === 0)) {
      return true;
    }
    if ((values?.bunkered?.lfo?.mass || values?.bunkered?.lfo?.mass === 0) && (values?.bunkered?.lfo?.volume || values?.bunkered?.lfo?.volume === 0) && (values?.bunkered?.lfo?.density || values?.bunkered?.lfo?.density === 0)) {
      return true;
    }
    if ((values?.bunkered?.lpgPropane?.mass || values?.bunkered?.lpgPropane?.mass === 0) && (values?.bunkered?.lpgPropane?.volume || values?.bunkered?.lpgPropane?.volume === 0) && (values?.bunkered?.lpgPropane?.density || values?.bunkered?.lpgPropane?.density === 0)) {
      return true;
    }
    if ((values?.bunkered?.lpgButane?.mass || values?.bunkered?.lpgButane?.mass === 0) && (values?.bunkered?.lpgButane?.volume || values?.bunkered?.lpgButane?.volume === 0) && (values?.bunkered?.lpgButane?.density || values?.bunkered?.lpgButane?.density === 0)) {
      return true;
    }
    if ((values?.bunkered?.lng?.mass || values?.bunkered?.lng?.mass === 0) && (values?.bunkered?.lng?.volume || values?.bunkered?.lng?.volume === 0) && (values?.bunkered?.lng?.density || values?.bunkered?.lng?.density === 0)) {
      return true;
    }
    if ((values?.bunkered?.methanol?.mass || values?.bunkered?.methanol?.mass === 0) && (values?.bunkered?.methanol?.volume || values?.bunkered?.methanol?.volume === 0) && (values?.bunkered?.methanol?.density || values?.bunkered?.methanol?.density === 0)) {
      return true;
    }
    if ((values?.bunkered?.ethanol?.mass || values?.bunkered?.ethanol?.mass === 0) && (values?.bunkered?.ethanol?.volume || values?.bunkered?.ethanol?.volume === 0) && (values?.bunkered?.ethanol?.density || values?.bunkered?.ethanol?.density === 0)) {
      return true;
    }
    if ((values?.bunkered?.others?.mass || values?.bunkered?.others?.mass === 0) && (values?.bunkered?.others?.volume || values?.bunkered?.others?.volume === 0) && (values?.bunkered?.others?.density || values?.bunkered?.others?.density === 0)) {
      return true;
    }
    return false;
  };

  const monitoringDataCheck = (values) => {
    if ((values?.fuelConsumption?.hsfo?.mass || values?.fuelConsumption?.hsfo?.mass === 0) && (values?.fuelConsumption?.hsfo?.calorificValue || values?.fuelConsumption?.hsfo?.calorificValue === 0) && values?.fuelConsumption?.hsfo?.calorificUnit) {
      return true;
    } else if ((values?.fuelConsumption?.mgo?.mass || values?.fuelConsumption?.mgo?.mass === 0) && (values?.fuelConsumption?.mgo?.calorificValue || values?.fuelConsumption?.mgo?.calorificValue === 0) && values?.fuelConsumption?.mgo?.calorificUnit) {
      return true;
    } else if ((values?.fuelConsumption?.lfo?.mass || values?.fuelConsumption?.lfo?.mass === 0) && (values?.fuelConsumption?.lfo?.calorificValue || values?.fuelConsumption?.lfo?.calorificValue === 0) && values?.fuelConsumption?.lfo?.calorificUnit) {
      return true;
    } else if ((values?.fuelConsumption?.mdo?.mass || values?.fuelConsumption?.mdo?.mass === 0) && (values?.fuelConsumption?.mdo?.calorificValue || values?.fuelConsumption?.mdo?.calorificValue === 0) && values?.fuelConsumption?.mdo?.calorificUnit) {
      return true;
    } else if ((values?.fuelConsumption?.lpgPropane?.mass || values?.fuelConsumption?.lpgPropane?.mass === 0) && (values?.fuelConsumption?.lpgPropane?.calorificValue || values?.fuelConsumption?.lpgPropane?.calorificValue === 0) && values?.fuelConsumption?.lpgPropane?.calorificUnit) {
      return true;
    } else if ((values?.fuelConsumption?.lpgButane?.mass || values?.fuelConsumption?.lpgButane?.mass === 0) && (values?.fuelConsumption?.lpgButane?.calorificValue || values?.fuelConsumption?.lpgButane?.calorificValue === 0) && values?.fuelConsumption?.lpgButane?.calorificUnit) {
      return true;
    } else if ((values?.fuelConsumption?.lng?.mass || values?.fuelConsumption?.lng?.mass === 0) && (values?.fuelConsumption?.lng?.calorificValue || values?.fuelConsumption?.lng?.calorificValue === 0) && values?.fuelConsumption?.lng?.calorificUnit) {
      return true;
    } else if ((values?.fuelConsumption?.methanol.mass || values?.fuelConsumption?.methanol.mass === 0) && (values?.fuelConsumption?.methanol.calorificValue || values?.fuelConsumption?.methanol.calorificValue === 0) && values?.fuelConsumption?.methanol.calorificUnit) {
      return true;
    } else if ((values?.fuelConsumption?.ethanol?.mass || values?.fuelConsumption?.ethanol?.mass === 0) && (values?.fuelConsumption?.ethanol?.calorificValue || values?.fuelConsumption?.ethanol?.calorificValue === 0) && values?.fuelConsumption?.ethanol?.calorificUnit) {
      return true;
    } else if ((values?.fuelConsumption?.others?.mass || values?.fuelConsumption?.others?.mass === 0) && (values?.fuelConsumption?.others?.calorificValue || values?.fuelConsumption?.others?.calorificValue === 0) && values?.fuelConsumption?.others?.calorificUnit) {
      return true;
    }
    return false;
  };

  const basicDetailsCheck = (values) => {
    if (!values?.reportDate || !values?.voyageStatus || !values?.latitude || !values?.longitude || !values?.latitudeDirection || !values?.longitudeDirection) {
      return false;
    }
    return true;
  };

  const transformPayload = (payload) => {
    return {
      voyageId: payload.voyageId,
      reportId: payload.reportId,
      imoNumber: payload?.imoNumber,
      voyageNo: payload?.voyageNo,
      reportDate: payload?.reportDate,
      longitude: parseFloat(payload?.longitude),
      latitude: parseFloat(payload?.latitude),
      longitudeDirection: payload.longitudeDirection,
      latitudeDirection: payload?.latitudeDirection,
      voyageStatus: payload?.voyageStatus,
      fuelConsumption: {
        hsfo: {
          mass: parseFloat(payload?.fuelConsumption?.hsfo?.mass),
          // sfoc: parseFloat(payload?.fuelConsumption?.hsfo?.sfoc),
          // sfocUnit: payload?.fuelConsumption?.hsfo?.sfocUnit,
          calorificValue: parseFloat(payload?.fuelConsumption?.hsfo?.calorificValue),
          calorificUnit: payload?.fuelConsumption?.hsfo?.calorificUnit,
        },
        mdo: {
          mass: parseFloat(payload?.fuelConsumption?.mdo?.mass),
          // sfoc: parseFloat(payload?.fuelConsumption?.mdo?.sfoc),
          // sfocUnit: payload?.fuelConsumption?.mdo?.sfocUnit,
          calorificValue: parseFloat(payload?.fuelConsumption?.mdo?.calorificValue),
          calorificUnit: payload?.fuelConsumption?.mdo?.calorificUnit,
        },
        mgo: {
          mass: parseFloat(payload?.fuelConsumption?.mgo?.mass),
          // sfoc: parseFloat(payload?.fuelConsumption?.mgo?.sfoc),
          // sfocUnit: payload?.fuelConsumption?.mgo?.sfocUnit,
          calorificValue: parseFloat(payload?.fuelConsumption?.mgo?.calorificValue),
          calorificUnit: payload?.fuelConsumption?.mgo?.calorificUnit,
        },
        lfo: {
          mass: parseFloat(payload?.fuelConsumption?.lfo?.mass),
          // sfoc: parseFloat(payload?.fuelConsumption?.lfo?.sfoc),
          // sfocUnit: payload?.fuelConsumption?.lfo?.sfocUnit,
          calorificValue: parseFloat(payload?.fuelConsumption?.lfo?.calorificValue),
          calorificUnit: payload?.fuelConsumption?.lfo?.calorificUnit,
        },
        lpgPropane: {
          mass: parseFloat(payload?.fuelConsumption?.lpgPropane?.mass),
          // sfoc: parseFloat(payload?.fuelConsumption?.lpgPropane?.sfoc),
          // sfocUnit: payload?.fuelConsumption?.lpgPropane?.sfocUnit,
          calorificValue: parseFloat(payload?.fuelConsumption?.lpgPropane?.calorificValue),
          calorificUnit: payload?.fuelConsumption?.lpgPropane?.calorificUnit,
        },
        lpgButane: {
          mass: parseFloat(payload?.fuelConsumption?.lpgButane?.mass),
          // sfoc: parseFloat(payload?.fuelConsumption?.lpgButane?.sfoc),
          // sfocUnit: payload?.fuelConsumption?.lpgButane?.sfocUnit,
          calorificValue: parseFloat(payload?.fuelConsumption?.lpgButane?.calorificValue),
          calorificUnit: payload?.fuelConsumption?.lpgButane?.calorificUnit,
        },
        lng: {
          mass: parseFloat(payload?.fuelConsumption?.lng?.mass),
          // sfoc: parseFloat(payload?.fuelConsumption?.lng?.sfoc),
          // sfocUnit: payload?.fuelConsumption?.lng?.sfocUnit,
          calorificValue: parseFloat(payload?.fuelConsumption?.lng?.calorificValue),
          calorificUnit: payload?.fuelConsumption?.lng?.calorificUnit,
        },
        methanol: {
          mass: parseFloat(payload?.fuelConsumption?.methanol?.mass),
          // sfoc: parseFloat(payload?.fuelConsumption?.methanol?.sfoc),
          // sfocUnit: payload?.fuelConsumption?.methanol?.sfocUnit,
          calorificValue: parseFloat(payload?.fuelConsumption?.methanol?.calorificValue),
          calorificUnit: payload?.fuelConsumption?.methanol?.calorificUnit,
        },
        ethanol: {
          mass: parseFloat(payload?.fuelConsumption?.ethanol?.mass),
          // sfoc: parseFloat(payload?.fuelConsumption?.ethanol?.sfoc),
          // sfocUnit: payload?.fuelConsumption?.ethanol?.sfocUnit,
          calorificValue: parseFloat(payload?.fuelConsumption?.ethanol?.calorificValue),
          calorificUnit: payload?.fuelConsumption?.ethanol?.calorificUnit,
        },
        others: {
          mass: parseFloat(payload?.fuelConsumption?.others?.mass),
          // sfoc: parseFloat(payload?.fuelConsumption?.others?.sfoc),
          // sfocUnit: payload?.fuelConsumption?.others?.sfocUnit,
          calorificValue: parseFloat(payload?.fuelConsumption?.others?.calorificValue),
          calorificUnit: payload?.fuelConsumption?.others?.calorificUnit,
        },
      },
      lastReportDistanceAndTime: {
        timeStamp: payload?.lastReportDistanceAndTime?.minutes && payload?.lastReportDistanceAndTime?.hours ? parseInt(payload?.lastReportDistanceAndTime?.hours) + '.' + parseInt(payload?.lastReportDistanceAndTime?.minutes) : payload?.lastReportDistanceAndTime?.hours ? parseInt(payload?.lastReportDistanceAndTime?.hours) + '.' + '00' : payload?.lastReportDistanceAndTime?.minutes ? '00' + '.' + parseInt(payload?.lastReportDistanceAndTime?.minutes) : null,
        heading: parseFloat(payload?.lastReportDistanceAndTime?.heading),
        averageSpeedOfGround: parseFloat(payload?.lastReportDistanceAndTime?.averageSpeedOfGround),
        averageSpeedOfWater: parseFloat(payload?.lastReportDistanceAndTime?.averageSpeedOfWater),
        distance: parseFloat(payload?.lastReportDistanceAndTime?.distance),
      },
      voyageState: {
        propellerRevolution: parseFloat(payload?.voyageState?.propellerRevolution),
        averageMEOutput: parseFloat(payload?.voyageState?.averageMEOutput),
        seaState: parseFloat(payload?.voyageState?.seaState),
        sfoc: parseFloat(payload?.voyageState?.sfoc),
        sfocUnit: payload?.voyageState?.sfocUnit,
        meRunningHours: payload?.voyageState?.minutes && payload?.voyageState?.hours ? parseInt(payload?.voyageState?.hours) + '.' + parseInt(payload?.voyageState?.minutes) : payload?.voyageState?.hours ? parseInt(payload?.voyageState?.hours) + '.' + '00' : payload?.voyageState?.minutes ? '00' + '.' + parseInt(payload?.voyageState?.minutes) : null,
      },
      portInformation: {
        portName: payload?.portInformation?.portName?.portName,
        portId: payload?.portInformation?.portName?._id,
        unloc: payload?.portInformation?.portName?.locationCode,
        isEuPort: payload?.portInformation?.isEuPort,
        isPortLoadingOrUnloading: payload?.portInformation.isPortLoadingOrUnloading,
        euPort: payload?.portInformation?.portName?.euPort ? payload?.portInformation?.portName?.euPort : false,
        portCountry: payload?.portInformation?.portName?.country,
      },
      bunkered: {
        hsfo: {
          mass: parseFloat(payload?.bunkered?.hsfo?.mass),
          volume: parseFloat(payload?.bunkered?.hsfo?.volume),
          density: parseFloat(payload?.bunkered?.hsfo?.density),
        },
        mdo: {
          mass: parseFloat(payload?.bunkered?.mdo?.mass),
          volume: parseFloat(payload?.bunkered?.mdo?.volume),
          density: parseFloat(payload?.bunkered?.mdo?.density),
        },
        mgo: {
          mass: parseFloat(payload?.bunkered?.mgo?.mass),
          volume: parseFloat(payload?.bunkered?.mgo?.volume),
          density: parseFloat(payload?.bunkered?.mgo?.density),
        },
        lfo: {
          mass: parseFloat(payload?.bunkered?.lfo?.mass),
          volume: parseFloat(payload?.bunkered?.lfo?.volume),
          density: parseFloat(payload?.bunkered?.lfo?.density),
        },
        lpgPropane: {
          mass: parseFloat(payload?.bunkered?.lpgPropane?.mass),
          volume: parseFloat(payload?.bunkered?.lpgPropane?.volume),
          density: parseFloat(payload?.bunkered?.lpgPropane?.density),
        },
        lpgButane: {
          mass: parseFloat(payload?.bunkered?.lpgButane?.mass),
          volume: parseFloat(payload?.bunkered?.lpgButane?.volume),
          density: parseFloat(payload?.bunkered?.lpgButane?.density),
        },
        lng: {
          mass: parseFloat(payload?.bunkered?.lng?.mass),
          volume: parseFloat(payload?.bunkered?.lng?.volume),
          density: parseFloat(payload?.bunkered?.lng?.density),
        },
        methanol: {
          mass: parseFloat(payload?.bunkered?.methanol?.mass),
          volume: parseFloat(payload?.bunkered?.methanol?.volume),
          density: parseFloat(payload?.bunkered?.methanol?.density),
        },
        ethanol: {
          mass: parseFloat(payload?.bunkered?.ethanol?.mass),
          volume: parseFloat(payload?.bunkered?.ethanol?.volume),
          density: parseFloat(payload?.bunkered?.ethanol?.density),
        },
        others: {
          mass: parseFloat(payload?.bunkered?.others?.mass),
          volume: parseFloat(payload?.bunkered?.others?.volume),
          density: parseFloat(payload?.bunkered?.others?.density),
        },
        bunkeredDeliveryNote: payload?.bunkered?.bunkeredDeliveryNote,
      },
      cargo: {
        loadingCondition: payload?.cargo?.loadingCondition,
        cargoCarried: parseFloat(payload?.cargo?.cargoCarried),
        billOfLoading: payload?.cargo?.billOfLoading,
      },
      remaingOnBoard: {
        hsfo: parseFloat(payload?.remaingOnBoard?.hsfo),
        mdo: parseFloat(payload?.remaingOnBoard?.mdo),
        mgo: parseFloat(payload?.remaingOnBoard?.mgo),
        lfo: parseFloat(payload?.remaingOnBoard?.lfo),
        lpgPropane: parseFloat(payload?.remaingOnBoard?.lpgPropane),
        lpgButane: parseFloat(payload?.remaingOnBoard?.lpgButane),
        lng: parseFloat(payload?.remaingOnBoard?.lng),
        methanol: parseFloat(payload?.remaingOnBoard?.methanol),
        ethanol: parseFloat(payload?.remaingOnBoard?.ethanol),
        others: parseFloat(payload?.remaingOnBoard?.others),
      },
    };
  };

  const handleAddNoonReport = async (values) => {
    dispatch(setLoading(true));
    const payload = {
      ...values,
    };
    if (values?.bunkered?.bunkeredDeliveryNote && values?.bunkered?.bunkeredDeliveryNote?.path) {
      try {
        payload.bunkered.bunkeredDeliveryNote = await uploadFileToS3(values.bunkered?.bunkeredDeliveryNote);
      } catch (e) {}
    }
    if (values.cargo?.billOfLoading && values.cargo?.billOfLoading?.path) {
      try {
        payload.cargo.billOfLoading = await uploadFileToS3(values.cargo?.billOfLoading);
      } catch (e) {}
    }
    const response = await appapi.post(`/fleet/noonReport`, transformPayload(payload));
    if (response.ok) {
      dispatch(setLoading(false));
      const data = response.data;
      if (data.status === '7400') {
        onModelHandleClose(true);
        showmessage(data.message);
      } else {
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!!`, 'error', 2000);
    }
    // console.log(transformPayload(payload), 'pppppppppppppppp');
  };

  const handleEditNoonReport = async (values) => {
    dispatch(setLoading(true));
    const payload = {
      ...values,
    };
    if (values?.bunkered?.bunkeredDeliveryNote && values?.bunkered?.bunkeredDeliveryNote?.path) {
      try {
        payload.bunkered.bunkeredDeliveryNote = await uploadFileToS3(values.bunkered?.bunkeredDeliveryNote);
      } catch (e) {}
    }
    if (values.cargo?.billOfLoading && values.cargo?.billOfLoading?.path) {
      try {
        payload.cargo.billOfLoading = await uploadFileToS3(values.cargo?.billOfLoading);
      } catch (e) {}
    }

    const response = await appapi.put(`/fleet/noonReport/${data?._id}`, transformPayload(payload));
    if (response.ok) {
      dispatch(setLoading(false));
      const data = response.data;
      if (data.status === '7400') {
        onModelHandleClose(true);
        showmessage(data.message);
      } else {
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!!`, 'error', 2000);
    }
  };

  useEffect(() => {
    if (voyageDetails) {
      getReportDetails();
    }
    return () => {
      if (source) {
        source.cancel();
      }
    };
  }, [voyageDetails]);

  useEffect(() => {
    getVoyageStates();
  }, []);

  const getReportDetails = async () => {
    setLoading(true);
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(
      `fleet/detailsForNoon/${voyageDetails?._id}`,
      {},
      {
        cancelToken: source.token,
      },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        setDetails(data.response);
      }
      setLoading(false);
    }
  };

  const getVoyageStates = async () => {
    setLoading(true);
    source2.cancel();
    source2 = CancelToken.source();
    const response = await appapi.get(
      `fleet/getVoyageState`,
      {
        pageNumber: 1,
        pageSize: 50,
      },
      {
        cancelToken: source.token,
      },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        setStates(data.response);
      }
      setLoading(false);
    }
  };

  const timeStamp = data?.lastReportDistanceAndTime?.timeStamp && (data?.lastReportDistanceAndTime?.timeStamp).toString();
  const timeStampArray =
    timeStamp?.length > 6
      ? moment(timeStamp)
          .format('HH:mm')
          ?.split(':')
          .reduce((acc, curr) => {
            acc.push(parseInt(curr)); // Convert each character back to a number
            return acc;
          }, [])
      : timeStamp?.split('.').reduce((acc, curr) => {
          acc.push(parseInt(curr)); // Convert each character back to a number
          return acc;
        }, []);

  const meRunningTime = data?.voyageState?.meRunningHours && (data?.voyageState?.meRunningHours).toString();
  const runningTimeArray = meRunningTime?.split('.').reduce((acc, curr) => {
    acc.push(parseInt(curr)); // Convert each character back to a number
    return acc;
  }, []);

  return (
    <Dialog
      sx={sx}
      open={modelOpen}
    >
      {loading && (
        <Stack
          flex={1}
          alignItems={'center'}
          justifyContent={'center'}
        >
          <ActivityIndicator />
        </Stack>
      )}
      {!loading && (
        <Stack
          flex={1}
          className="m-[8px] rounded-[8px] bg-white"
        >
          <Stack flex={1}>
            <Formik
              innerRef={formRef}
              enableReinitialize={true}
              validationSchema={validationSchema}
              initialValues={{
                voyageId: data?.VoyageId ? data?.VoyageId : voyageDetails?._id,
                reportId: data?.reportId ? data?.reportId : voyageDetails?.reportId,
                imoNumber: data?.imoNumber ? data?.imoNumber : voyageDetails?.imoNumber,
                voyageNo: data?.voyageNo ? data?.voyageNo : voyageDetails?.voyageNo,
                reportDate: data?.reportDate ? dayjs(new Date(data?.reportDate)) : undefined,
                longitude: data?.longitude ? data?.longitude : null,
                latitude: data?.latitude ? data?.latitude : null,
                longitudeDirection: data?.longitudeDirection ? data?.longitudeDirection : 'E',
                latitudeDirection: data?.latitudeDirection ? data?.latitudeDirection : 'N',
                voyageStatus: data?.voyageStatus ? data?.voyageStatus : null,
                fuelConsumption: {
                  hsfo: {
                    mass: data?.reportId ? data?.fuelConsumption?.hsfo?.mass : null,
                    // sfoc: data?.fuelConsumption?.hsfo?.sfoc ? data?.fuelConsumption?.hsfo?.sfoc : null,
                    // sfocUnit: data?.fuelConsumption?.hsfo?.sfocUnit ? data?.fuelConsumption?.hsfo?.sfocUnit : 'g/kwh',
                    calorificValue: data?.reportId ? data?.fuelConsumption?.hsfo?.calorificValue : null,
                    calorificUnit: data?.fuelConsumption?.hsfo?.calorificUnit ? data?.fuelConsumption?.hsfo?.calorificUnit : 'kcal/kg',
                  },
                  mdo: {
                    mass: data?.reportId ? data?.fuelConsumption?.mdo?.mass : null,
                    // sfoc: data?.fuelConsumption?.mdo?.sfoc ? data?.fuelConsumption?.mdo?.sfoc : null,
                    // sfocUnit: data?.fuelConsumption?.mdo?.sfocUnit ? data?.fuelConsumption?.mdo?.sfocUnit : 'g/kwh',
                    calorificValue: data?.reportId ? data?.fuelConsumption?.mdo?.calorificValue : null,
                    calorificUnit: data?.fuelConsumption?.mdo?.calorificUnit ? data?.fuelConsumption?.mdo?.calorificUnit : 'kcal/kg',
                  },
                  mgo: {
                    mass: data?.reportId ? data?.fuelConsumption?.mgo?.mass : null,
                    // sfoc: data?.fuelConsumption?.mgo?.sfoc ? data?.fuelConsumption?.mgo?.sfoc : null,
                    // sfocUnit: data?.fuelConsumption?.mgo?.sfocUnit ? data?.fuelConsumption?.mgo?.sfocUnit : 'g/kwh',
                    calorificValue: data?.reportId ? data?.fuelConsumption?.mgo?.calorificValue : null,
                    calorificUnit: data?.fuelConsumption?.mgo?.calorificUnit ? data?.fuelConsumption?.mgo?.calorificUnit : 'kcal/kg',
                  },
                  lfo: {
                    mass: data?.reportId ? data?.fuelConsumption?.lfo?.mass : null,
                    // sfoc: data?.fuelConsumption?.lfo?.sfoc ? data?.fuelConsumption?.lfo?.sfoc : null,
                    // sfocUnit: data?.fuelConsumption?.lfo?.sfocUnit ? data?.fuelConsumption?.lfo?.sfocUnit : 'g/kwh',
                    calorificValue: data?.reportId ? data?.fuelConsumption?.lfo?.calorificValue : null,
                    calorificUnit: data?.fuelConsumption?.lfo?.calorificUnit ? data?.fuelConsumption?.lfo?.calorificUnit : 'kcal/kg',
                  },
                  lpgPropane: {
                    mass: data?.reportId ? data?.fuelConsumption?.lpgPropane?.mass : null,
                    // sfoc: data?.fuelConsumption?.lpgPropane?.sfoc ? data?.fuelConsumption?.lpgPropane?.sfoc : null,
                    // sfocUnit: data?.fuelConsumption?.lpgPropane?.sfocUnit ? data?.fuelConsumption?.lpgPropane?.sfocUnit : 'g/kwh',
                    calorificValue: data?.reportId ? data?.fuelConsumption?.lpgPropane?.calorificValue : null,
                    calorificUnit: data?.fuelConsumption?.lpgPropane?.calorificUnit ? data?.fuelConsumption?.lpgPropane?.calorificUnit : 'kcal/kg',
                  },
                  lpgButane: {
                    mass: data?.reportId ? data?.fuelConsumption?.lpgButane?.mass : null,
                    // sfoc: data?.fuelConsumption?.lpgButane?.sfoc ? data?.fuelConsumption?.lpgButane?.sfoc : null,
                    // sfocUnit: data?.fuelConsumption?.lpgButane?.sfocUnit ? data?.fuelConsumption?.lpgButane?.sfocUnit : 'g/kwh',
                    calorificValue: data?.reportId ? data?.fuelConsumption?.lpgButane?.calorificValue : null,
                    calorificUnit: data?.fuelConsumption?.lpgButane?.calorificUnit ? data?.fuelConsumption?.lpgButane?.calorificUnit : 'kcal/kg',
                  },
                  lng: {
                    mass: data?.reportId ? data?.fuelConsumption?.lng?.mass : null,
                    // sfoc: data?.fuelConsumption?.lng?.sfoc ? data?.fuelConsumption?.lng?.sfoc : null,
                    // sfocUnit: data?.fuelConsumption?.lng?.sfocUnit ? data?.fuelConsumption?.lng?.sfocUnit : 'g/kwh',
                    calorificValue: data?.reportId ? data?.fuelConsumption?.lng?.calorificValue : null,
                    calorificUnit: data?.fuelConsumption?.lng?.calorificUnit ? data?.fuelConsumption?.lng?.calorificUnit : 'kcal/kg',
                  },
                  methanol: {
                    mass: data?.reportId ? data?.fuelConsumption?.methanol?.mass : null,
                    // sfoc: data?.fuelConsumption?.methanol?.sfoc ? data?.fuelConsumption?.methanol?.sfoc : null,
                    // sfocUnit: data?.fuelConsumption?.methanol?.sfocUnit ? data?.fuelConsumption?.methanol?.sfocUnit : 'g/kwh',
                    calorificValue: data?.reportId ? data?.fuelConsumption?.methanol?.calorificValue : null,
                    calorificUnit: data?.fuelConsumption?.methanol?.calorificUnit ? data?.fuelConsumption?.methanol?.calorificUnit : 'kcal/kg',
                  },
                  ethanol: {
                    mass: data?.reportId ? data?.fuelConsumption?.ethanol?.mass : null,
                    // sfoc: data?.fuelConsumption?.ethanol?.sfoc ? data?.fuelConsumption?.ethanol?.sfoc : null,
                    // sfocUnit: data?.fuelConsumption?.ethanol?.sfocUnit ? data?.fuelConsumption?.ethanol?.sfocUnit : 'g/kwh',
                    calorificValue: data?.reportId ? data?.fuelConsumption?.ethanol?.calorificValue : null,
                    calorificUnit: data?.fuelConsumption?.ethanol?.calorificUnit ? data?.fuelConsumption?.ethanol?.calorificUnit : 'kcal/kg',
                  },
                  others: {
                    mass: data?.reportId ? data?.fuelConsumption?.others?.mass : null,
                    // sfoc: data?.fuelConsumption?.others?.sfoc ? data?.fuelConsumption?.others?.sfoc : null,
                    // sfocUnit: data?.fuelConsumption?.others?.sfocUnit ? data?.fuelConsumption?.others?.sfocUnit : 'g/kwh',
                    calorificValue: data?.reportId ? data?.fuelConsumption?.others?.calorificValue : null,
                    calorificUnit: data?.fuelConsumption?.others?.calorificUnit ? data?.fuelConsumption?.others?.calorificUnit : 'kcal/kg',
                  },
                },
                lastReportDistanceAndTime: {
                  // timeStamp: data?.lastReportDistanceAndTime?.timeStamp ? dayjs(new Date(data?.lastReportDistanceAndTime?.timeStamp)) : null,
                  isTimeStamp: data?.reportId ? !data?.lastReportDistanceAndTime?.timeStamp : false,
                  hours: data?.lastReportDistanceAndTime?.timeStamp ? timeStampArray[0] : null,
                  minutes: data?.lastReportDistanceAndTime?.timeStamp ? timeStampArray[1] : null,
                  heading: data?.reportId ? data?.lastReportDistanceAndTime?.heading : null,
                  averageSpeedOfGround: data?.reportId ? data?.lastReportDistanceAndTime?.averageSpeedOfGround : null,
                  averageSpeedOfWater: data?.reportId ? data?.lastReportDistanceAndTime?.averageSpeedOfWater : null,
                  distance: data?.reportId ? data?.lastReportDistanceAndTime?.distance : null,
                },
                voyageState: {
                  propellerRevolution: data?.reportId ? data?.voyageState?.propellerRevolution : null,
                  averageMEOutput: data?.reportId ? data?.voyageState?.averageMEOutput : null,
                  seaState: data?.reportId ? data?.voyageState?.seaState : null,
                  sfoc: data?.reportId ? data?.voyageState?.sfoc : initReportDetails?.voyageState?.sfoc || '',
                  sfocUnit: data?.voyageState?.sfocUnit ? data?.voyageState?.sfocUnit : initReportDetails?.voyageState?.sfocUnit || 'g/kwh',
                  hours: data?.voyageState?.meRunningHours ? runningTimeArray[0] : null,
                  minutes: data?.voyageState?.meRunningHours ? runningTimeArray[1] : null,
                },
                portInformation: {
                  portName: data?.portInformation?.portName
                    ? {
                        portName: data?.portInformation?.portName,
                        _id: data?.portInformation?.portId,
                        locationCode: data?.portInformation?.unloc,
                        euPort: data?.portInformation?.euPort,
                        country: data?.portInformation?.portCountry,
                      }
                    : null,
                  portId: data?.portInformation?.portId ? data?.portInformation?.portId : null,
                  unloc: data?.portInformation?.unloc ? data?.portInformation?.unloc : '',
                  isEuPort: data?.portInformation?.isEuPort ? data?.portInformation?.isEuPort : false,
                  isPortLoadingOrUnloading: data?.portInformation?.isPortLoadingOrUnloading ? data?.portInformation?.isPortLoadingOrUnloading : false,
                  euPort: data?.portInformation?.euPort ? data?.portInformation?.euPort : null,
                  portCountry: data?.AddNoonReport?.portCountry ? data?.portInformation?.portCountry : null,
                },
                bunkered: {
                  hsfo: {
                    mass: data?.reportId ? data?.bunkered?.hsfo?.mass : null,
                    volume: data?.reportId ? data?.bunkered?.hsfo?.volume : null,
                    density: data?.reportId ? data?.bunkered?.hsfo?.density : null,
                  },
                  mdo: {
                    mass: data?.reportId ? data?.bunkered?.mdo?.mass : null,
                    volume: data?.reportId ? data?.bunkered?.mdo?.volume : null,
                    density: data?.reportId ? data?.bunkered?.mdo?.density : null,
                  },
                  mgo: {
                    mass: data?.reportId ? data?.bunkered?.mgo?.mass : null,
                    volume: data?.reportId ? data?.bunkered?.mgo?.volume : null,
                    density: data?.reportId ? data?.bunkered?.mgo?.density : null,
                  },
                  lfo: {
                    mass: data?.reportId ? data?.bunkered?.lfo?.mass : null,
                    volume: data?.reportId ? data?.bunkered?.lfo?.volume : null,
                    density: data?.reportId ? data?.bunkered?.lfo?.density : null,
                  },
                  lpgPropane: {
                    mass: data?.reportId ? data?.bunkered?.lpgPropane?.mass : null,
                    volume: data?.reportId ? data?.bunkered?.lpgPropane?.volume : null,
                    density: data?.reportId ? data?.bunkered?.lpgPropane?.density : null,
                  },
                  lpgButane: {
                    mass: data?.reportId ? data?.bunkered?.lpgButane?.mass : null,
                    volume: data?.reportId ? data?.bunkered?.lpgButane?.volume : null,
                    density: data?.reportId ? data?.bunkered?.lpgButane?.density : null,
                  },
                  lng: {
                    mass: data?.reportId ? data?.bunkered?.lng?.mass : null,
                    volume: data?.reportId ? data?.bunkered?.lng?.volume : null,
                    density: data?.reportId ? data?.bunkered?.lng?.density : null,
                  },
                  methanol: {
                    mass: data?.reportId ? data?.bunkered?.methanol?.mass : null,
                    volume: data?.reportId ? data?.bunkered?.methanol?.volume : null,
                    density: data?.reportId ? data?.bunkered?.methanol?.density : null,
                  },
                  ethanol: {
                    mass: data?.reportId ? data?.bunkered?.ethanol?.mass : null,
                    volume: data?.reportId ? data?.bunkered?.ethanol?.volume : null,
                    density: data?.reportId ? data?.bunkered?.ethanol?.density : null,
                  },
                  others: {
                    mass: data?.reportId ? data?.bunkered?.others?.mass : null,
                    volume: data?.reportId ? data?.bunkered?.others?.volume : null,
                    density: data?.reportId ? data?.bunkered?.others?.density : null,
                  },
                  bunkeredDeliveryNote: data?.bunkered?.bunkeredDeliveryNote || null,
                },
                cargo: {
                  loadingCondition: data?.cargo?.loadingCondition ? data?.cargo?.loadingCondition : initReportDetails?.cargo?.loadingCondition || '',
                  cargoCarried: data?.cargo?.cargoCarried ? data?.cargo?.cargoCarried : initReportDetails?.cargo?.cargoCarried || '',
                  billOfLoading: data?.cargo?.billOfLoading ? data?.cargo?.billOfLoading : null,
                },
                remaingOnBoard: {
                  hsfo: data?.reportId ? data?.remaingOnBoard?.hsfo : null,
                  mdo: data?.reportId ? data?.remaingOnBoard?.mdo : null,
                  mgo: data?.reportId ? data?.remaingOnBoard?.mgo : null,
                  lfo: data?.reportId ? data?.remaingOnBoard?.lfo : null,
                  lpgPropane: data?.reportId ? data?.remaingOnBoard?.lpgPropane : null,
                  lpgButane: data?.reportId ? data?.remaingOnBoard?.lpgButane : null,
                  lng: data?.reportId ? data?.remaingOnBoard?.lng : null,
                  methanol: data?.reportId ? data?.remaingOnBoard?.methanol : null,
                  ethanol: data?.reportId ? data?.remaingOnBoard?.ethanol : null,
                  others: data?.reportId ? data?.remaingOnBoard?.others : null,
                },
              }}
              // validationSchema={validationSchema}
              onSubmit={(values) => {
                if (data) {
                  handleEditNoonReport(values);
                } else {
                  handleAddNoonReport(values);
                }
              }}
            >
              {({ name, values, touched, errors, handleChange, handleBlur, isValid, dirty, setFieldValue }) => (
                <Form autoComplete="off">
                  <Stack
                    className="sticky top-[0] h-[66px]  bg-white"
                    style={{ backgroundColor: '#FFFFFF', zIndex: 6 }}
                  >
                    <Stack
                      direction={'row'}
                      alignItems={'center'}
                      justifyContent={'space-between'}
                    >
                      <Typography
                        flex={0.1}
                        className="fw-medium ff-Roboto fs-14 !capitalize"
                        color={text}
                      >
                        {t('Noon report')}
                      </Typography>
                      <Stack
                        direction="row"
                        alignItems={'center'}
                        className="!ml-[40px]"
                        flex={0.8}
                      >
                        <Stack
                          direction={'row'}
                          alignItems={'center'}
                          flex={0.2}
                        >
                          {basicDetailsCheck(values) ? (
                            <Stack style={{ width: '24px', height: '24px', borderRadius: '12px', alignItems: 'center', justifyContent: 'center', backgroundColor: '#FFCC00' }}>
                              <DoneIcon style={{ color: '#000000', transform: 'scale(0.7)' }} />
                            </Stack>
                          ) : (
                            <Stack style={{ width: '24px', height: '24px', borderRadius: '12px', alignItems: 'center', justifyContent: 'center', backgroundColor: '#003399' }}>
                              {/* <DoneIcon style={{ color: '#000000', transform: 'scale(0.7)' }} /> */}
                              <Typography
                                className="fw-regular ff-Roboto fs-12"
                                color={'#ffffff'}
                              >
                                1
                              </Typography>
                            </Stack>
                          )}

                          <Typography
                            className="fw-medium ff-Roboto fs-12 !ml-[10px]"
                            color={text}
                          >
                            {t('Basic details')}
                          </Typography>
                          <Stack
                            style={{ height: '1px', backgroundColor: '#DCDFE6' }}
                            flexGrow={1}
                            className="mx-[5px]"
                          />
                        </Stack>
                        <Stack
                          direction={'row'}
                          alignItems={'center'}
                          flex={0.2}
                        >
                          {monitoringDataCheck(values) && distanceAndTimeCheck(values) && voyageStateCheck(values) && portCheck(values) ? (
                            <Stack style={{ width: '24px', height: '24px', borderRadius: '12px', alignItems: 'center', justifyContent: 'center', backgroundColor: '#FFCC00' }}>
                              <DoneIcon style={{ color: '#000000', transform: 'scale(0.7)' }} />
                            </Stack>
                          ) : (
                            <Stack style={{ width: '24px', height: '24px', borderRadius: '12px', alignItems: 'center', justifyContent: 'center', backgroundColor: '#003399' }}>
                              {/* <DoneIcon style={{ color: '#000000', transform: 'scale(0.7)' }} /> */}
                              <Typography
                                className="fw-regular ff-Roboto fs-12"
                                color={'#ffffff'}
                              >
                                2
                              </Typography>
                            </Stack>
                          )}
                          <Typography
                            className="fw-medium ff-Roboto fs-12 !ml-[10px] !capitalize"
                            color={text}
                          >
                            {t('Monitoring data')}
                          </Typography>
                          <Stack
                            style={{ height: '1px', backgroundColor: '#DCDFE6' }}
                            flexGrow={1}
                            className="mx-[5px]"
                          />
                          {/* <Stack
                          direction={'row'}
                          alignItems={'center'}
                          className="!ml-[10px]"
                        >
                          <Stack style={{ height: '1px', width: '20px', backgroundColor: '#DCDFE6' }} />
                          <Stack style={{ height: '8px', width: '8px', backgroundColor: basicDetailsCheck(values) ? '#14285A' : '#DCDFE6', borderRadius: '4px' }}></Stack>
                          <Stack style={{ height: '1px', width: '20px', backgroundColor: '#DCDFE6' }} />
                          <Stack style={{ height: '8px', width: '8px', backgroundColor: basicDetailsCheck(values) && monitoringDataCheck(values) && distanceAndTimeCheck(values) && voyageStateCheck(values) && portCheck(values) ? '#14285A' : '#DCDFE6', borderRadius: '4px' }}></Stack>
                          <Stack style={{ height: '1px', width: '20px', backgroundColor: '#DCDFE6' }} />
                          <Stack style={{ height: '8px', width: '8px', backgroundColor: basicDetailsCheck(values) && monitoringDataCheck(values) && distanceAndTimeCheck(values) && voyageStateCheck(values) && portCheck(values) && bunkeredDataCheck(values) ? '#14285A' : '#DCDFE6', borderRadius: '4px' }}></Stack>
                          <Stack style={{ height: '1px', width: '20px', backgroundColor: '#DCDFE6' }} />
                          <Stack style={{ height: '8px', width: '8px', backgroundColor: basicDetailsCheck(values) && monitoringDataCheck(values) && distanceAndTimeCheck(values) && voyageStateCheck(values) && portCheck(values) && bunkeredDataCheck(values) && cargoCheck(values) ? '#14285A' : '#DCDFE6', borderRadius: '4px' }}></Stack>
                          <Stack style={{ height: '1px', width: '20px', backgroundColor: '#DCDFE6' }} />
                          <Stack style={{ height: '8px', width: '8px', backgroundColor: basicDetailsCheck(values) && monitoringDataCheck(values) && distanceAndTimeCheck(values) && voyageStateCheck(values) && portCheck(values) && bunkeredDataCheck(values) && cargoCheck(values) && robCheck(values) ? '#14285A' : '#DCDFE6', borderRadius: '4px' }}></Stack>
                          <Stack style={{ height: '1px', width: '20px', backgroundColor: '#DCDFE6' }} />
                        </Stack> */}
                        </Stack>
                        <Stack
                          direction={'row'}
                          alignItems={'center'}
                          flex={0.2}
                        >
                          {bunkeredDataCheck(values) ? (
                            <Stack style={{ width: '24px', height: '24px', borderRadius: '12px', alignItems: 'center', justifyContent: 'center', backgroundColor: '#FFCC00' }}>
                              <DoneIcon style={{ color: '#000000', transform: 'scale(0.7)' }} />
                            </Stack>
                          ) : (
                            <Stack style={{ width: '24px', height: '24px', borderRadius: '12px', alignItems: 'center', justifyContent: 'center', backgroundColor: '#003399' }}>
                              <Typography
                                className="fw-regular ff-Roboto fs-12"
                                color={'#ffffff'}
                              >
                                3
                              </Typography>
                            </Stack>
                          )}

                          <Typography
                            className="fw-medium ff-Roboto fs-12 !ml-[10px]"
                            color={text}
                          >
                            {t('Bunkered')}
                          </Typography>
                          <Stack
                            style={{ height: '1px', backgroundColor: '#DCDFE6' }}
                            flexGrow={1}
                            className="mx-[5px]"
                          />
                        </Stack>
                        <Stack
                          direction={'row'}
                          alignItems={'center'}
                          flex={0.2}
                        >
                          {cargoCheck(values) ? (
                            <Stack style={{ width: '24px', height: '24px', borderRadius: '12px', alignItems: 'center', justifyContent: 'center', backgroundColor: '#FFCC00' }}>
                              <DoneIcon style={{ color: '#000000', transform: 'scale(0.7)' }} />
                            </Stack>
                          ) : (
                            <Stack style={{ width: '24px', height: '24px', borderRadius: '12px', alignItems: 'center', justifyContent: 'center', backgroundColor: '#003399' }}>
                              <Typography
                                className="fw-regular ff-Roboto fs-12"
                                color={'#ffffff'}
                              >
                                4
                              </Typography>
                            </Stack>
                          )}

                          <Typography
                            className="fw-medium ff-Roboto fs-12 !ml-[10px]"
                            color={text}
                          >
                            {t('Cargo')}
                          </Typography>
                          <Stack
                            style={{ height: '1px', backgroundColor: '#DCDFE6' }}
                            flexGrow={1}
                            className="mx-[5px]"
                          />
                        </Stack>
                        <Stack
                          direction={'row'}
                          alignItems={'center'}
                          flex={0.2}
                        >
                          {robCheck(values) ? (
                            <Stack style={{ width: '24px', height: '24px', borderRadius: '12px', alignItems: 'center', justifyContent: 'center', backgroundColor: '#FFCC00' }}>
                              <DoneIcon style={{ color: '#000000', transform: 'scale(0.7)' }} />
                            </Stack>
                          ) : (
                            <Stack style={{ width: '24px', height: '24px', borderRadius: '12px', alignItems: 'center', justifyContent: 'center', backgroundColor: '#003399' }}>
                              <Typography
                                className="fw-regular ff-Roboto fs-12"
                                color={'#ffffff'}
                              >
                                5
                              </Typography>
                            </Stack>
                          )}

                          <Typography
                            className="fw-medium ff-Roboto fs-12 !ml-[10px] !capitalize"
                            color={text}
                          >
                            {t('ROB')}
                          </Typography>
                        </Stack>
                      </Stack>
                      <IconButton
                        flex={0.1}
                        onClick={() => {
                          onModelHandleClose(false);
                        }}
                      >
                        <ClearIcon style={{ transform: 'scale(1)', color: '#14285A' }} />
                      </IconButton>
                    </Stack>
                    <Stack
                      style={{ backgroundColor: '#8993AC26', width: '100%', height: '2px' }}
                      className="mt-[10px]"
                    />
                  </Stack>
                  <Stack className="px-[240px]">
                    <Stack
                      direction={'row'}
                      flex={1}
                    >
                      {basicDetailsCheck(values) && (
                        <Stack
                          style={{ width: '8px', height: '48px', backgroundColor: '#FFCC00', position: 'absolute' }}
                          className="ml-[0.5%] rounded-tl-[4px] rounded-bl-[4px] mt-[2%]"
                        ></Stack>
                      )}

                      <Stack
                        style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', borderWidth: '1px', borderColor: '#8993AC26' }}
                        className="my-[15px] p-[16px] mx-[15px]"
                        flex={1}
                      >
                        <Typography
                          className="fw-regular ff-Roboto fs-16 !capitalize"
                          color={text}
                        >
                          {t('Basic details')}
                        </Typography>
                        <Typography
                          className="fw-regular ff-Roboto fs-12 !mb-[16px]"
                          color={textLight}
                        >
                          {t('Some info may be visible to other people using ZeroEmission services')}
                        </Typography>
                        <Stack
                          direction={'row'}
                          alignItems={'center'}
                        >
                          <Typography
                            className="fw-regular ff-Roboto fs-12"
                            color={text}
                          >
                            {t('Voyage no.')}
                          </Typography>
                          <Stack
                            style={{ alignItems: 'center', justifyContent: 'center', backgroundColor: '#00A632' }}
                            className="h-[12px] w-[12px] rounded-[6px] ml-[10px] !mb-[2px]"
                          >
                            <DoneIcon style={{ color: '#ffffff', transform: 'scale(0.5)' }} />
                          </Stack>
                        </Stack>
                        <Typography
                          className="fw-medium ff-Roboto fs-14 !mb-[16px]"
                          color={text}
                        >
                          {voyageDetails?.voyageNo}
                        </Typography>
                        <Stack
                          direction={'row'}
                          flex={1}
                          alignItems={'center'}
                        >
                          <Stack flex={0.5}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DateTimePicker
                              timezone='UTC'                               
                                minDate={dayjs(new Date(voyageDetails?.fromDate))}
                                timeSteps={{ hours: 1, minutes: 1, seconds: 1 }}
                                label={t('Report date') + ' (UTC) *'}
                                value={values?.reportDate}
                                onChange={(newValue) => setFieldValue('reportDate', newValue)}
                                renderInput={(params) => (
                                  <TextField
                                    onKeyDown={(event) => {
                                      event.preventDefault();
                                    }}
                                    variant="outlined"
                                    {...params}
                                  />
                                )}
                              />
                            </LocalizationProvider>
                          </Stack>
                          <Stack
                            flex={0.5}
                            className="mt-[18px] ml-[10px]"
                          >
                            <FormSelectField
                              name="voyageStatus"
                              label={t('Voyage status') + ' *'}
                            >
                              {voyageStatus?.length === 0 && (
                                <MenuItem
                                  disabled
                                  value=""
                                >
                                  <em>{t('No Data Found')}</em>
                                </MenuItem>
                              )}
                              {voyageStatus?.map((item) => (
                                <MenuItem
                                  key={item.id}
                                  value={item.voyageStatus}
                                >
                                  <div style={{ textTransform: 'capitalize' }}>{t(item.voyageStatus)}</div>
                                </MenuItem>
                              ))}
                            </FormSelectField>
                          </Stack>
                        </Stack>
                        <Stack
                          direction={'row'}
                          flex={1}
                          alignItems={'center'}
                        >
                          <Stack
                            flex={0.5}
                            className="mr-[10px]"
                          >
                            <FormTextField
                              outlineLabel={t('Latitude')}
                              name="latitude"
                              onlyFloat={true}
                              requiredMark={true}
                              whiteSpace={true}
                              inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <Stack
                                      direction={'row'}
                                      alignItems={'center'}
                                      style={{ cursor: 'pointer' }}
                                    >
                                      <Stack
                                        style={{ backgroundColor: values?.latitudeDirection === 'N' ? '#14285A' : '#8993AC1A', borderTopLeftRadius: '16px', borderBottomLeftRadius: '16px', width: '40px', height: '32px', alignItems: 'center', justifyContent: 'center' }}
                                        onClick={() => setFieldValue('latitudeDirection', 'N')}
                                      >
                                        <Typography
                                          className="fw-regular ff-Roboto fs-14"
                                          color={values?.latitudeDirection === 'N' ? '#FFFFFF' : '#14285A'}
                                        >
                                          N
                                        </Typography>
                                      </Stack>
                                      <Stack
                                        style={{ backgroundColor: values?.latitudeDirection === 'S' ? '#14285A' : '#8993AC1A', borderTopRightRadius: '16px', borderBottomRightRadius: '16px', width: '40px', height: '32px', alignItems: 'center', justifyContent: 'center' }}
                                        onClick={() => setFieldValue('latitudeDirection', 'S')}
                                      >
                                        <Typography
                                          className="fw-regular ff-Roboto fs-14"
                                          color={values?.latitudeDirection === 'S' ? '#FFFFFF' : '#14285A'}
                                        >
                                          S
                                        </Typography>
                                      </Stack>
                                    </Stack>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Stack>
                          <Stack flex={0.5}>
                            <FormTextField
                              outlineLabel={t('Longitude')}
                              name="longitude"
                              onlyFloat={true}
                              // type={'number'}
                              requiredMark={true}
                              whiteSpace={true}
                              inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <Stack
                                      direction={'row'}
                                      alignItems={'center'}
                                      style={{ cursor: 'pointer' }}
                                    >
                                      <Stack
                                        style={{ backgroundColor: values?.longitudeDirection === 'E' ? '#14285A' : '#8993AC1A', borderTopLeftRadius: '16px', borderBottomLeftRadius: '16px', width: '40px', height: '32px', alignItems: 'center', justifyContent: 'center' }}
                                        onClick={() => setFieldValue('longitudeDirection', 'E')}
                                      >
                                        <Typography
                                          className="fw-regular ff-Roboto fs-14"
                                          color={values?.longitudeDirection === 'E' ? '#FFFFFF' : '#14285A'}
                                        >
                                          E
                                        </Typography>
                                      </Stack>
                                      <Stack
                                        style={{ backgroundColor: values?.longitudeDirection === 'W' ? '#14285A' : '#8993AC1A', borderTopRightRadius: '16px', borderBottomRightRadius: '16px', width: '40px', height: '32px', alignItems: 'center', justifyContent: 'center' }}
                                        onClick={() => setFieldValue('longitudeDirection', 'W')}
                                      >
                                        <Typography
                                          className="fw-regular ff-Roboto fs-14"
                                          color={values?.longitudeDirection === 'W' ? '#FFFFFF' : '#14285A'}
                                        >
                                          W
                                        </Typography>
                                      </Stack>
                                    </Stack>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Stack>
                        </Stack>
                      </Stack>
                    </Stack>

                    <Stack
                      direction={'row'}
                      flex={1}
                    >
                      <Stack
                        style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', borderWidth: '1px', borderColor: '#8993AC26' }}
                        className="m-[15px] pt-[16px]"
                        flex={1}
                      >
                        <Stack className="!px-[16px]">
                          <Typography
                            className="fw-regular ff-Roboto fs-16 !px=[16px]"
                            color={text}
                          >
                            {t('Monitoring data')}
                          </Typography>
                          <Typography
                            className="fw-regular ff-Roboto fs-12 !mb-[16px] "
                            color={textLight}
                          >
                            {t('Some info may be visible to other people using ZeroEmission services')}
                          </Typography>
                        </Stack>

                        <Stack className="px-[16px]">
                          <Stack
                            style={{ backgroundColor: '#8993AC26', width: '100%', height: '1px' }}
                            className=""
                          />
                        </Stack>

                        <Stack
                          direction={'row'}
                          alignItems={'center'}
                          className="mt-[16px]"
                          flex={1}
                        >
                          <Stack flex={0.6}>
                            <Stack
                              direction={'row'}
                              // alignItems={'center'}
                            >
                              <Stack className="!ml-[-10px]">
                                <ArrowRightIcon style={{ transform: 'scale(1.4) ', color: monitoringDataCheck(values) ? '#FFCC00' : null }} />
                              </Stack>
                              <Stack className="">
                                <Typography
                                  className="fw-regular ff-Roboto fs-14 !capitalize"
                                  color={text}
                                >
                                  {t('Fuel oil consumption')}
                                </Typography>
                                <Typography
                                  className="fw-regular ff-Roboto fs-12 "
                                  color={textLight}
                                >
                                  ({t('From last report')})
                                </Typography>
                              </Stack>
                            </Stack>
                          </Stack>
                          {/* <Stack
                          flex={0.185}
                          className=""
                        >
                          <Stack
                            direction={'row'}
                            alignItems={'center'}
                          >
                            <Typography
                              className="fw-regular ff-Roboto fs-12 !mr-[5px]"
                              color={textLight}
                            >
                              *
                            </Typography>
                            <Typography
                              className="fw-regular ff-Roboto fs-12 "
                              color={textLight}
                            >
                              {t('Specific Fuel Oil Consumption')} (SFOC)
                            </Typography>
                          </Stack>
                        </Stack>
                        <Stack
                          flex={0.1}
                          direction={'row'}
                          alignItems={'center'}
                          justifyContent={'flex-end'}
                        >
                          <Typography
                            className="fw-regular ff-Roboto fs-12 "
                            color={textLight}
                          >
                            {sfocUnit}
                          </Typography>
                          <Stack
                            alignItems={'center'}
                            justifyContent={'center'}
                          >
                            <ArrowDropUpIcon
                              onClick={() => {
                                setSfocUnit('g/kwh');
                                setFieldValue('fuelConsumption.hsfo.sfocUnit', 'g/kwh');
                                setFieldValue('fuelConsumption.mdo.sfocUnit', 'g/kwh');
                                setFieldValue('fuelConsumption.mgo.sfocUnit', 'g/kwh');
                                setFieldValue('fuelConsumption.lfo.sfocUnit', 'g/kwh');
                                setFieldValue('fuelConsumption.lpgPropane.sfocUnit', 'g/kwh');
                                setFieldValue('fuelConsumption.lpgButane.sfocUnit', 'g/kwh');
                                setFieldValue('fuelConsumption.lng.sfocUnit', 'g/kwh');
                                setFieldValue('fuelConsumption.methanol.sfocUnit', 'g/kwh');
                                setFieldValue('fuelConsumption.ethanol.sfocUnit', 'g/kwh');
                                setFieldValue('fuelConsumption.others.sfocUnit', 'g/kwh');
                              }}
                              style={{ cursor: 'pointer', color: sfocUnit === 'g/kwh' ? '#8993AC' : '#8993AC59' }}
                            />

                            <ArrowDropDownIcon
                              onClick={() => {
                                setSfocUnit('kg/kwh');
                                setFieldValue('fuelConsumption.hsfo.sfocUnit', 'kg/kwh');
                                setFieldValue('fuelConsumption.mdo.sfocUnit', 'kg/kwh');
                                setFieldValue('fuelConsumption.mgo.sfocUnit', 'kg/kwh');
                                setFieldValue('fuelConsumption.lfo.sfocUnit', 'kg/kwh');
                                setFieldValue('fuelConsumption.lpgPropane.sfocUnit', 'kg/kwh');
                                setFieldValue('fuelConsumption.lpgButane.sfocUnit', 'kg/kwh');
                                setFieldValue('fuelConsumption.lng.sfocUnit', 'kg/kwh');
                                setFieldValue('fuelConsumption.methanol.sfocUnit', 'kg/kwh');
                                setFieldValue('fuelConsumption.ethanol.sfocUnit', 'kg/kwh');
                                setFieldValue('fuelConsumption.others.sfocUnit', 'kg/kwh');
                              }}
                              style={{ cursor: 'pointer', color: sfocUnit === 'kg/kwh' ? '#8993AC' : '#8993AC59' }}
                            />
                          </Stack>
                        </Stack> */}
                          <Stack
                            flex={0.5}
                            className="ml-[26px]"
                          >
                            <Typography
                              className="fw-regular ff-Roboto fs-12"
                              color={textLight}
                            >
                              * {t('Calorific value')}
                            </Typography>
                          </Stack>
                          <Stack
                            flex={0.1}
                            direction={'row'}
                            alignItems={'center'}
                            justifyContent={'flex-end'}
                            className="!pr-[16px]"
                          >
                            <Typography
                              className="fw-regular ff-Roboto fs-12 "
                              color={textLight}
                            >
                              {calorificUnit}
                            </Typography>
                            <Stack
                              alignItems={'center'}
                              justifyContent={'center'}
                            >
                              <ArrowDropUpIcon
                                onClick={() => {
                                  setCalorific('kcal/kg');
                                  setFieldValue('fuelConsumption.hsfo.calorificUnit', 'kcal/kg');
                                  setFieldValue('fuelConsumption.mdo.calorificUnit', 'kcal/kg');
                                  setFieldValue('fuelConsumption.mgo.calorificUnit', 'kcal/kg');
                                  setFieldValue('fuelConsumption.lfo.calorificUnit', 'kcal/kg');
                                  setFieldValue('fuelConsumption.lpgPropane.calorificUnit', 'kcal/kg');
                                  setFieldValue('fuelConsumption.lpgButane.calorificUnit', 'kcal/kg');
                                  setFieldValue('fuelConsumption.lng.calorificUnit', 'kcal/kg');
                                  setFieldValue('fuelConsumption.methanol.calorificUnit', 'kcal/kg');
                                  setFieldValue('fuelConsumption.ethanol.calorificUnit', 'kcal/kg');
                                  setFieldValue('fuelConsumption.others.calorificUnit', 'kcal/kg');
                                }}
                                style={{ cursor: 'pointer', color: calorificUnit === 'kcal/kg' ? '#8993AC' : '#8993AC59' }}
                              />

                              <ArrowDropDownIcon
                                onClick={() => {
                                  setCalorific('mj/kg');
                                  setFieldValue('fuelConsumption.hsfo.calorificUnit', 'mj/kg');
                                  setFieldValue('fuelConsumption.mdo.calorificUnit', 'mj/kg');
                                  setFieldValue('fuelConsumption.mgo.calorificUnit', 'mj/kg');
                                  setFieldValue('fuelConsumption.lfo.calorificUnit', 'mj/kg');
                                  setFieldValue('fuelConsumption.lpgPropane.calorificUnit', 'mj/kg');
                                  setFieldValue('fuelConsumption.lpgButane.calorificUnit', 'mj/kg');
                                  setFieldValue('fuelConsumption.lng.calorificUnit', 'mj/kg');
                                  setFieldValue('fuelConsumption.methanol.calorificUnit', 'mj/kg');
                                  setFieldValue('fuelConsumption.ethanol.calorificUnit', 'mj/kg');
                                  setFieldValue('fuelConsumption.others.calorificUnit', 'mj/kg');
                                }}
                                style={{ cursor: 'pointer', color: calorificUnit === 'mj/kg' ? '#8993AC' : '#8993AC59' }}
                              />
                            </Stack>
                          </Stack>
                        </Stack>
                        <Stack
                          direction={'row'}
                          alignItems={'center'}
                          className="mt-[16px] !px-[16px]"
                        >
                          <Stack
                            flex={0.5}
                            className="mr-[10px]"
                          >
                            <FormTextField
                              outlineLabel={'HFO'}
                              name="fuelConsumption.hsfo.mass"
                              onlyFloat={true}
                              inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                            />
                          </Stack>

                          <Stack flex={0.5}>
                            <FormTextField
                              outlineLabel={t('Calorific value')}
                              name="fuelConsumption.hsfo.calorificValue"
                              onlyFloat={true}
                              // requiredMark={true}
                              whiteSpace={true}
                              inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <ChooseMeasurementValue
                                      unitType1={'kcal/kg'}
                                      unitType2={'mj/kg'}
                                      onClickUp={() => setFieldValue('fuelConsumption.hsfo.calorificUnit', 'kcal/kg')}
                                      onClickDown={() => setFieldValue('fuelConsumption.hsfo.calorificUnit', 'mj/kg')}
                                      selectedUnit={values?.fuelConsumption.hsfo.calorificUnit}
                                    />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Stack>
                        </Stack>
                        <Stack
                          direction={'row'}
                          alignItems={'center'}
                          className="mt-[16px] !px-[16px]"
                        >
                          <Stack
                            flex={0.5}
                            className="mr-[10px]"
                          >
                            <FormTextField
                              outlineLabel={'MDO'}
                              name="fuelConsumption.mdo.mass"
                              onlyFloat={true}
                              // requiredMark={true}
                              whiteSpace={true}
                              inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                            />
                          </Stack>

                          <Stack flex={0.5}>
                            <FormTextField
                              outlineLabel={t('Calorific value')}
                              name="fuelConsumption.mdo.calorificValue"
                              onlyFloat={true}
                              // requiredMark={true}
                              whiteSpace={true}
                              inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <ChooseMeasurementValue
                                      unitType1={'kcal/kg'}
                                      unitType2={'mj/kg'}
                                      onClickUp={() => setFieldValue('fuelConsumption.mdo.calorificUnit', 'kcal/kg')}
                                      onClickDown={() => setFieldValue('fuelConsumption.mdo.calorificUnit', 'mj/kg')}
                                      selectedUnit={values?.fuelConsumption.mdo.calorificUnit}
                                    />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Stack>
                        </Stack>
                        <Stack
                          direction={'row'}
                          alignItems={'center'}
                          className="mt-[16px] !px-[16px]"
                        >
                          <Stack
                            flex={0.5}
                            className="mr-[10px]"
                          >
                            <FormTextField
                              outlineLabel={'MGO'}
                              name="fuelConsumption.mgo.mass"
                              onlyFloat={true}
                              // requiredMark={true}
                              whiteSpace={true}
                              inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                            />
                          </Stack>

                          <Stack flex={0.5}>
                            <FormTextField
                              outlineLabel={t('Calorific value')}
                              name="fuelConsumption.mgo.calorificValue"
                              onlyFloat={true}
                              // requiredMark={true}
                              whiteSpace={true}
                              inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <ChooseMeasurementValue
                                      unitType1={'kcal/kg'}
                                      unitType2={'mj/kg'}
                                      onClickUp={() => setFieldValue('fuelConsumption.mgo.calorificUnit', 'kcal/kg')}
                                      onClickDown={() => setFieldValue('fuelConsumption.mgo.calorificUnit', 'mj/kg')}
                                      selectedUnit={values?.fuelConsumption.mgo.calorificUnit}
                                    />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Stack>
                        </Stack>
                        <Stack
                          direction={'row'}
                          alignItems={'center'}
                          className="mt-[16px] !px-[16px]"
                        >
                          <Stack
                            flex={0.5}
                            className="mr-[10px]"
                          >
                            <FormTextField
                              outlineLabel={'LFO'}
                              name="fuelConsumption.lfo.mass"
                              onlyFloat={true}
                              // requiredMark={true}
                              whiteSpace={true}
                              inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                            />
                          </Stack>

                          <Stack flex={0.5}>
                            <FormTextField
                              outlineLabel={t('Calorific value')}
                              name="fuelConsumption.lfo.calorificValue"
                              onlyFloat={true}
                              // requiredMark={true}
                              whiteSpace={true}
                              inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <ChooseMeasurementValue
                                      unitType1={'kcal/kg'}
                                      unitType2={'mj/kg'}
                                      onClickUp={() => setFieldValue('fuelConsumption.lfo.calorificUnit', 'kcal/kg')}
                                      onClickDown={() => setFieldValue('fuelConsumption.lfo.calorificUnit', 'mj/kg')}
                                      selectedUnit={values?.fuelConsumption.lfo.calorificUnit}
                                    />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Stack>
                        </Stack>
                        <Stack
                          direction={'row'}
                          alignItems={'center'}
                          className="mt-[16px] !px-[16px]"
                        >
                          <Stack
                            flex={0.5}
                            className="mr-[10px]"
                          >
                            <FormTextField
                              outlineLabel={t('LPG propane')}
                              name="fuelConsumption.lpgPropane.mass"
                              onlyFloat={true}
                              // requiredMark={true}
                              whiteSpace={true}
                              inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                            />
                          </Stack>

                          <Stack flex={0.5}>
                            <FormTextField
                              outlineLabel={t('Calorific value')}
                              name="fuelConsumption.lpgPropane.calorificValue"
                              onlyFloat={true}
                              // requiredMark={true}
                              whiteSpace={true}
                              inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <ChooseMeasurementValue
                                      unitType1={'kcal/kg'}
                                      unitType2={'mj/kg'}
                                      onClickUp={() => setFieldValue('fuelConsumption.lpgPropane.calorificUnit', 'kcal/kg')}
                                      onClickDown={() => setFieldValue('fuelConsumption.lpgPropane.calorificUnit', 'mj/kg')}
                                      selectedUnit={values?.fuelConsumption.lpgPropane.calorificUnit}
                                    />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Stack>
                        </Stack>
                        <Stack
                          direction={'row'}
                          alignItems={'center'}
                          className="mt-[16px] !px-[16px]"
                        >
                          <Stack
                            flex={0.5}
                            className="mr-[10px]"
                          >
                            <FormTextField
                              outlineLabel={t('LPG butane')}
                              name="fuelConsumption.lpgButane.mass"
                              onlyFloat={true}
                              // requiredMark={true}
                              whiteSpace={true}
                              inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                            />
                          </Stack>

                          <Stack flex={0.5}>
                            <FormTextField
                              outlineLabel={t('Calorific value')}
                              name="fuelConsumption.lpgButane.calorificValue"
                              onlyFloat={true}
                              // requiredMark={true}
                              whiteSpace={true}
                              inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <ChooseMeasurementValue
                                      unitType1={'kcal/kg'}
                                      unitType2={'mj/kg'}
                                      onClickUp={() => setFieldValue('fuelConsumption.lpgButane.calorificUnit', 'kcal/kg')}
                                      onClickDown={() => setFieldValue('fuelConsumption.lpgButane.calorificUnit', 'mj/kg')}
                                      selectedUnit={values?.fuelConsumption.lpgButane.calorificUnit}
                                    />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Stack>
                        </Stack>
                        <Stack
                          direction={'row'}
                          alignItems={'center'}
                          className="mt-[16px] !px-[16px]"
                        >
                          <Stack
                            flex={0.5}
                            className="mr-[10px]"
                          >
                            <FormTextField
                              outlineLabel={'LNG'}
                              name="fuelConsumption.lng.mass"
                              onlyFloat={true}
                              // requiredMark={true}
                              whiteSpace={true}
                              inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                            />
                          </Stack>

                          <Stack flex={0.5}>
                            <FormTextField
                              outlineLabel={t('Calorific value')}
                              name="fuelConsumption.lng.calorificValue"
                              onlyFloat={true}
                              // requiredMark={true}
                              whiteSpace={true}
                              inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <ChooseMeasurementValue
                                      unitType1={'kcal/kg'}
                                      unitType2={'mj/kg'}
                                      onClickUp={() => setFieldValue('fuelConsumption.lng.calorificUnit', 'kcal/kg')}
                                      onClickDown={() => setFieldValue('fuelConsumption.lng.calorificUnit', 'mj/kg')}
                                      selectedUnit={values?.fuelConsumption.lng.calorificUnit}
                                    />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Stack>
                        </Stack>
                        <Stack
                          direction={'row'}
                          alignItems={'center'}
                          className="mt-[16px] !px-[16px]"
                        >
                          <Stack
                            flex={0.5}
                            className="mr-[10px]"
                          >
                            <FormTextField
                              outlineLabel={t('Methanol')}
                              name="fuelConsumption.methanol.mass"
                              onlyFloat={true}
                              // requiredMark={true}
                              whiteSpace={true}
                              inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                            />
                          </Stack>

                          <Stack flex={0.5}>
                            <FormTextField
                              outlineLabel={t('Calorific value')}
                              name="fuelConsumption.methanol.calorificValue"
                              onlyFloat={true}
                              // requiredMark={true}
                              whiteSpace={true}
                              inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <ChooseMeasurementValue
                                      unitType1={'kcal/kg'}
                                      unitType2={'mj/kg'}
                                      onClickUp={() => setFieldValue('fuelConsumption.methanol.calorificUnit', 'kcal/kg')}
                                      onClickDown={() => setFieldValue('fuelConsumption.methanol.calorificUnit', 'mj/kg')}
                                      selectedUnit={values?.fuelConsumption.methanol.calorificUnit}
                                    />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Stack>
                        </Stack>
                        <Stack
                          direction={'row'}
                          alignItems={'center'}
                          className="mt-[16px] !px-[16px]"
                        >
                          <Stack
                            flex={0.5}
                            className="mr-[10px]"
                          >
                            <FormTextField
                              outlineLabel={t('Ethanol')}
                              name="fuelConsumption.ethanol.mass"
                              onlyFloat={true}
                              // requiredMark={true}
                              whiteSpace={true}
                              inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                            />
                          </Stack>

                          <Stack flex={0.5}>
                            <FormTextField
                              outlineLabel={t('Calorific value')}
                              name="fuelConsumption.ethanol.calorificValue"
                              onlyFloat={true}
                              // requiredMark={true}
                              whiteSpace={true}
                              inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <ChooseMeasurementValue
                                      unitType1={'kcal/kg'}
                                      unitType2={'mj/kg'}
                                      onClickUp={() => setFieldValue('fuelConsumption.ethanol.calorificUnit', 'kcal/kg')}
                                      onClickDown={() => setFieldValue('fuelConsumption.ethanol.calorificUnit', 'mj/kg')}
                                      selectedUnit={values?.fuelConsumption.ethanol.calorificUnit}
                                    />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Stack>
                        </Stack>
                        <Stack
                          direction={'row'}
                          alignItems={'center'}
                          className="mt-[16px] !px-[16px]"
                        >
                          <Stack
                            flex={0.5}
                            className="mr-[10px]"
                          >
                            <FormTextField
                              outlineLabel={t('Others')}
                              name="fuelConsumption.others.mass"
                              onlyFloat={true}
                              // requiredMark={true}
                              whiteSpace={true}
                              inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                            />
                          </Stack>

                          <Stack flex={0.5}>
                            <FormTextField
                              outlineLabel={t('Calorific value')}
                              name="fuelConsumption.others.calorificValue"
                              onlyFloat={true}
                              // requiredMark={true}
                              whiteSpace={true}
                              inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <ChooseMeasurementValue
                                      unitType1={'kcal/kg'}
                                      unitType2={'mj/kg'}
                                      onClickUp={() => setFieldValue('fuelConsumption.others.calorificUnit', 'kcal/kg')}
                                      onClickDown={() => setFieldValue('fuelConsumption.others.calorificUnit', 'mj/kg')}
                                      selectedUnit={values?.fuelConsumption.others.calorificUnit}
                                    />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Stack>
                        </Stack>
                        <Stack className="px-[16px]">
                          <Stack
                            style={{ backgroundColor: '#8993AC26', width: '100%', height: '1px' }}
                            className="!my-[16px]"
                          />
                        </Stack>
                        <Stack direction={'row'}>
                          <Stack className="!ml-[-10px]">
                            <ArrowRightIcon style={{ transform: 'scale(1.4) ', color: distanceAndTimeCheck(values) ? '#FFCC00' : null }} />
                          </Stack>

                          <Stack>
                            <Typography
                              className="fw-regular ff-Roboto fs-14 "
                              color={text}
                            >
                              {t('Distance and time')}
                            </Typography>
                            <Typography
                              className="fw-regular ff-Roboto fs-12 "
                              color={textLight}
                            >
                              ({t('From last report')})
                            </Typography>
                          </Stack>
                        </Stack>

                        <Stack
                          direction={'row'}
                          flex={1}
                          alignItems={'center'}
                          className="mt-[16px] !px-[16px]"
                        >
                          <Stack
                            flex={0.25}
                            className="mr-[10px] mt-[10px] "
                          >
                            <FormTextField
                              outlineLabel={t('Hours')}
                              name="lastReportDistanceAndTime.hours"
                              onlyNumber={true}
                              whiteSpace={true}
                              inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                              disabled={values?.lastReportDistanceAndTime?.isTimeStamp}
                            />
                          </Stack>

                          <Stack
                            flex={0.25}
                            className="mt-[10px]"
                          >
                            <FormTextField
                              outlineLabel={t('Minutes')}
                              name="lastReportDistanceAndTime.minutes"
                              onlyMinutes={true}
                              whiteSpace={true}
                              inputProps={{ maxLength: 2 }}
                              sx={{ marginBottom: '10px' }}
                              disabled={values?.lastReportDistanceAndTime?.isTimeStamp}
                            />
                          </Stack>

                          <Stack
                            flex={0.25}
                            className="mx-[10px] mt-[10px]"
                          >
                            <FormTextField
                              outlineLabel={t('Heading')}
                              name="lastReportDistanceAndTime.heading"
                              // requiredMark={true}
                              // onlyAlpha={true}
                              onlyFloat={true}
                              whiteSpace={true}
                              inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <Typography>deg</Typography>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Stack>
                          <Stack
                            flex={0.25}
                            className="mt-[10px]"
                          >
                            <FormTextField
                              outlineLabel={t('Distance')}
                              name="lastReportDistanceAndTime.distance"
                              onlyFloat={true}
                              onlyAlpha={false}
                              requiredMark={true}
                              whiteSpace={true}
                              inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <Typography>nm</Typography>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Stack>
                        </Stack>
                        <Stack
                          direction={'row'}
                          alignItems={'center'}
                          flex={0.5}
                          className="px-[16px]"
                        >
                          <Typography
                            className="fw-regular ff-Roboto fs-14 !capitalize"
                            color={text}
                          >
                            {t('First Report')} ?
                          </Typography>
                          <Stack
                            direction={'row'}
                            alignItems={'center'}
                          >
                            <Switch
                              checked={values?.lastReportDistanceAndTime?.isTimeStamp}
                              onChange={() => {
                                setFieldValue('lastReportDistanceAndTime.isTimeStamp', !values?.lastReportDistanceAndTime?.isTimeStamp);
                                setFieldValue('lastReportDistanceAndTime.hours', '');
                                setFieldValue('lastReportDistanceAndTime.minutes', '');
                              }}
                              inputProps={{ 'aria-label': 'controlled' }}
                              // disabled={values?.portInformation?.portName?.euPort === 'N'}
                            />
                            <Typography
                              className="fw-regular ff-Roboto fs-14 "
                              color={text}
                            >
                              {values?.lastReportDistanceAndTime?.isTimeStamp ? t('Yes') : t('No')}
                            </Typography>
                          </Stack>
                        </Stack>
                        <Stack
                          direction={'row'}
                          flex={1}
                          alignItems={'center'}
                          className="mt-[16px] !px-[16px]"
                        >
                          <Stack
                            flex={0.5}
                            className="mt-[10px] "
                          >
                            <FormTextField
                              outlineLabel={t('Average speed (ground)')}
                              name="lastReportDistanceAndTime.averageSpeedOfGround"
                              onlyFloat={true}
                              onlyAlpha={false}
                              // requiredMark={true}
                              whiteSpace={true}
                              inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <Typography>kts</Typography>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Stack>
                          <Stack
                            flex={0.5}
                            className="mt-[10px] ml-[10px]"
                          >
                            <FormTextField
                              outlineLabel={t('Average speed (water)')}
                              name="lastReportDistanceAndTime.averageSpeedOfWater"
                              onlyFloat={true}
                              onlyAlpha={false}
                              // requiredMark={true}
                              whiteSpace={true}
                              inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <Typography>kts</Typography>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Stack>
                        </Stack>
                        <Stack className="px-[16px]">
                          <Stack
                            style={{ backgroundColor: '#8993AC26', width: '100%', height: '1px' }}
                            className="!my-[16px]"
                          />
                        </Stack>
                        <Stack
                          direction={'row'}
                          alignItems={'center'}
                        >
                          <Stack className="!ml-[-10px]">
                            <ArrowRightIcon style={{ transform: 'scale(1.4) ', color: voyageStateCheck(values) ? '#FFCC00' : null }} />
                          </Stack>

                          <Typography
                            className="fw-regular ff-Roboto fs-14 !capitalize"
                            color={text}
                          >
                            {t('Voyage state')}
                          </Typography>
                        </Stack>
                        <Stack
                          direction={'row'}
                          flex={1}
                          alignItems={'center'}
                          className="mt-[16px] !px-[16px]"
                        >
                          <Stack flex={0.5}>
                            <FormTextField
                              outlineLabel={t('Propeller revolution')}
                              name="voyageState.propellerRevolution"
                              onlyFloat={true}
                              onlyAlpha={false}
                              // requiredMark={true}
                              whiteSpace={true}
                              inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                            />
                          </Stack>
                          <Stack
                            flex={0.5}
                            className="ml-[10px]"
                          >
                            <FormTextField
                              outlineLabel={t('Specific Fuel Oil Consumption')}
                              name="voyageState.sfoc"
                              onlyFloat={true}
                              onlyAlpha={false}
                              requiredMark={true}
                              whiteSpace={true}
                              // inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <ChooseMeasurementValue
                                      unitType1={'g/kwh'}
                                      unitType2={'kg/kwh'}
                                      onClickUp={() => setFieldValue('voyageState.sfocUnit', 'g/kwh')}
                                      onClickDown={() => setFieldValue('voyageState.sfocUnit', 'kg/kwh')}
                                      selectedUnit={values?.voyageState.sfocUnit}
                                    />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Stack>
                        </Stack>
                        <Typography
                          className="fw-regular ff-Roboto fs-14 !capitalize !mt-[10px] !ml-[16px]"
                          color={text}
                        >
                          {t('ME Running Hours')}
                        </Typography>
                        <Stack
                          direction={'row'}
                          flex={1}
                          alignItems={'center'}
                          className="mt-[16px] !px-[16px]"
                        >
                          <Stack flex={0.25}>
                            <FormTextField
                              outlineLabel={t('Hours') + ' *'}
                              name="voyageState.hours"
                              onlyFloat={true}
                              onlyAlpha={false}
                              // requiredMark={true}
                              whiteSpace={true}
                              inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                            />
                          </Stack>
                          <Stack
                            flex={0.25}
                            className="mx-[10px]"
                          >
                            <FormTextField
                              outlineLabel={t('Minutes') + ' *'}
                              name="voyageState.minutes"
                              onlyFloat={true}
                              onlyAlpha={false}
                              // requiredMark={true}
                              whiteSpace={true}
                              inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                            />
                          </Stack>
                          <Stack
                            flex={0.25}
                            className="mr-[10px]"
                          >
                            <FormTextField
                              outlineLabel={t('Average ME output')}
                              name="voyageState.averageMEOutput"
                              onlyFloat={true}
                              onlyAlpha={false}
                              // requiredMark={true}
                              whiteSpace={true}
                              inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                            />
                          </Stack>
                          <Stack flex={0.25}>
                            <FormTextField
                              outlineLabel={t('Sea state')}
                              name="voyageState.seaState"
                              type={'number'}
                              onlyNumber={true}
                              onlyAlpha={false}
                              // requiredMark={true}
                              whiteSpace={true}
                              inputProps={{ maxLength: 10 }}
                              sx={{ marginBottom: '10px' }}
                              // min={0}
                            />
                          </Stack>
                        </Stack>
                        <Stack className="px-[16px]">
                          <Stack
                            style={{ backgroundColor: '#8993AC26', width: '100%', height: '1px' }}
                            className="!my-[16px]"
                          />
                        </Stack>
                        <Stack
                          direction={'row'}
                          alignItems={'center'}
                        >
                          <Stack className="!ml-[-10px]">
                            <ArrowRightIcon style={{ transform: 'scale(1.4) ', color: portCheck(values) ? '#FFCC00' : null }} />
                          </Stack>

                          <Typography
                            className="fw-regular ff-Roboto fs-14 "
                            color={text}
                          >
                            {t('Port Information (Arrival)')}
                          </Typography>
                        </Stack>
                        <Stack
                          direction={'row'}
                          flex={1}
                          alignItems={'center'}
                          className="mt-[16px] !px-[16px]"
                        >
                          <Stack
                            flex={0.5}
                            className="mr-[10px] !mb-[10px]"
                          >
                            {/* <FormTextField
                            outlineLabel={'Port Name'}
                            name="portInformation.portName"
                            requiredMark={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                          /> */}
                            <PortDropDown
                              selectedId={null}
                              lable={t('Port name') + ' *'}
                              name="portInformation.portName"
                              onSelect={(e) =>
                                setTimeout(() => {
                                  setFieldValue('portInformation.unloc', e?.locationCode);
                                  if (e.euPort === 'Y') {
                                    setFieldValue('portInformation.isEuPort', true);
                                  } else {
                                    setFieldValue('portInformation.isEuPort', false);
                                  }
                                }, 500)
                              }
                            />
                          </Stack>

                          <Stack flex={0.5}>
                            <FormTextField
                              value={values?.portInformation?.unloc}
                              outlineLabel={t('UNLOC')}
                              name="portInformation.unloc"
                              sx={{ marginBottom: '10px' }}
                              disabled={true}
                              // disabled={values?.portInformation?.unloc}
                            />
                          </Stack>
                        </Stack>
                        <Stack
                          direction={'row'}
                          alignItems={'center'}
                          justifyContent={'space-between'}
                          className="!px-[16px]"
                        >
                          <Stack
                            direction={'row'}
                            alignItems={'center'}
                            flex={0.5}
                          >
                            <Typography
                              className="fw-regular ff-Roboto fs-14 !capitalize"
                              color={text}
                            >
                              {t('EU port')} ?
                            </Typography>
                            <Stack
                              direction={'row'}
                              alignItems={'center'}
                            >
                              <Switch
                                checked={values?.portInformation?.isEuPort}
                                onChange={() => setFieldValue('portInformation.isEuPort', !values?.portInformation?.isEuPort)}
                                inputProps={{ 'aria-label': 'controlled' }}
                                // disabled={values?.portInformation?.portName?.euPort === 'N'}
                              />
                              <Typography
                                className="fw-regular ff-Roboto fs-14 "
                                color={text}
                              >
                                {values?.portInformation?.isEuPort ? t('Yes') : t('No')}
                              </Typography>
                            </Stack>
                          </Stack>{' '}
                          <Stack
                            direction={'row'}
                            alignItems={'center'}
                            flex={0.5}
                            className="!ml-[16px]"
                          >
                            <Typography
                              className="fw-regular ff-Roboto fs-14 "
                              color={text}
                            >
                              {t('Port Loading / Unloading')}
                            </Typography>
                            <Stack
                              direction={'row'}
                              alignItems={'center'}
                            >
                              <Switch
                                checked={values?.portInformation?.isPortLoadingOrUnloading}
                                onChange={() => setFieldValue('portInformation.isPortLoadingOrUnloading', !values?.portInformation?.isPortLoadingOrUnloading)}
                                inputProps={{ 'aria-label': 'controlled' }}
                              />
                              <Typography
                                className="fw-regular ff-Roboto fs-14 "
                                color={text}
                              >
                                {values?.portInformation?.isPortLoadingOrUnloading ? t('Yes') : t('No')}
                              </Typography>
                            </Stack>
                          </Stack>
                        </Stack>
                      </Stack>
                    </Stack>

                    <Stack
                      style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', borderWidth: '1px', borderColor: '#8993AC26' }}
                      className="m-[15px] p-[16px]"
                    >
                      <Typography
                        className="fw-regular ff-Roboto fs-16"
                        color={text}
                      >
                        {t('Bunkered')}
                      </Typography>
                      <Typography
                        className="fw-regular ff-Roboto fs-12 !mb-[16px]"
                        color={textLight}
                      >
                        {t('Some info may be visible to other people using ZeroEmission services')}
                      </Typography>
                      <Stack className="mt-[16px]  w-[48%]">
                        <FileUploadField
                          placeholder={t('Upload bunker delivery note')}
                          url={values?.bunkered?.bunkeredDeliveryNote || null}
                          inputId={`doc1`}
                          handleFile={(files) => handleFile(files)}
                          showFileName={true}
                          fileName={t('Bunkered Delivery Notes')}
                          bgColor={'#64717C3B'}
                          height={'50px'}
                        />
                      </Stack>
                      <Stack
                        direction={'row'}
                        alignItems={'center'}
                        className="mt-[16px]"
                      >
                        <Stack flex={0.5}>
                          <FormTextField
                            outlineLabel={'HFO'}
                            name="bunkered.hsfo.mass"
                            onlyFloat={true}
                            // requiredMark={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>mt</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                        <Stack
                          flex={0.25}
                          className="mx-[16px]"
                        >
                          <FormTextField
                            outlineLabel={t('Volume')}
                            name="bunkered.hsfo.volume"
                            onlyFloat={true}
                            // requiredMark={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>m³</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                        <Stack flex={0.25}>
                          <FormTextField
                            outlineLabel={t('Density')}
                            name="bunkered.hsfo.density"
                            onlyFloat={true}
                            // requiredMark={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>kg/m³</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                      </Stack>
                      <Stack
                        direction={'row'}
                        alignItems={'center'}
                        className="mt-[16px]"
                      >
                        <Stack flex={0.5}>
                          <FormTextField
                            outlineLabel={'MDO'}
                            name="bunkered.mdo.mass"
                            onlyFloat={true}
                            // requiredMark={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>mt</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                        <Stack
                          flex={0.25}
                          className="mx-[16px]"
                        >
                          <FormTextField
                            outlineLabel={t('Volume')}
                            name="bunkered.mdo.volume"
                            onlyFloat={true}
                            // requiredMark={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>m³</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                        <Stack flex={0.25}>
                          <FormTextField
                            outlineLabel={t('Density')}
                            name="bunkered.mdo.density"
                            onlyFloat={true}
                            // requiredMark={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>kg/m³</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                      </Stack>
                      <Stack
                        direction={'row'}
                        alignItems={'center'}
                        className="mt-[16px]"
                      >
                        <Stack flex={0.5}>
                          <FormTextField
                            outlineLabel={'MGO'}
                            name="bunkered.mgo.mass"
                            onlyFloat={true}
                            // requiredMark={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>mt</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                        <Stack
                          flex={0.25}
                          className="mx-[16px]"
                        >
                          <FormTextField
                            outlineLabel={t('Volume')}
                            name="bunkered.mgo.volume"
                            onlyFloat={true}
                            // requiredMark={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>m³</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                        <Stack flex={0.25}>
                          <FormTextField
                            outlineLabel={t('Density')}
                            name="bunkered.mgo.density"
                            onlyFloat={true}
                            // requiredMark={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>kg/m³</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                      </Stack>
                      <Stack
                        direction={'row'}
                        alignItems={'center'}
                        className="mt-[16px]"
                      >
                        <Stack flex={0.5}>
                          <FormTextField
                            outlineLabel={'LFO'}
                            name="bunkered.lfo.mass"
                            onlyFloat={true}
                            // requiredMark={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>mt</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                        <Stack
                          flex={0.25}
                          className="mx-[16px]"
                        >
                          <FormTextField
                            outlineLabel={t('Volume')}
                            name="bunkered.lfo.volume"
                            onlyFloat={true}
                            // requiredMark={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>m³</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                        <Stack flex={0.25}>
                          <FormTextField
                            outlineLabel={t('Density')}
                            name="bunkered.lfo.density"
                            onlyFloat={true}
                            // requiredMark={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>kg/m³</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                      </Stack>
                      <Stack
                        direction={'row'}
                        alignItems={'center'}
                        className="mt-[16px]"
                      >
                        <Stack flex={0.5}>
                          <FormTextField
                            outlineLabel={t('LPG propane')}
                            name="bunkered.lpgPropane.mass"
                            onlyFloat={true}
                            // requiredMark={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>mt</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                        <Stack
                          flex={0.25}
                          className="mx-[16px]"
                        >
                          <FormTextField
                            outlineLabel={t('Volume')}
                            name="bunkered.lpgPropane.volume"
                            onlyFloat={true}
                            // requiredMark={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>m³</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                        <Stack flex={0.25}>
                          <FormTextField
                            outlineLabel={t('Density')}
                            name="bunkered.lpgPropane.density"
                            onlyFloat={true}
                            // requiredMark={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>kg/m³</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                      </Stack>
                      <Stack
                        direction={'row'}
                        alignItems={'center'}
                        className="mt-[16px]"
                      >
                        <Stack flex={0.5}>
                          <FormTextField
                            outlineLabel={t('LPG butane')}
                            name="bunkered.lpgButane.mass"
                            onlyFloat={true}
                            // requiredMark={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>mt</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                        <Stack
                          flex={0.25}
                          className="mx-[16px]"
                        >
                          <FormTextField
                            outlineLabel={t('Volume')}
                            name="bunkered.lpgButane.volume"
                            onlyFloat={true}
                            // requiredMark={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>m³</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                        <Stack flex={0.25}>
                          <FormTextField
                            outlineLabel={t('Density')}
                            name="bunkered.lpgButane.density"
                            onlyFloat={true}
                            // requiredMark={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>kg/m³</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                      </Stack>
                      <Stack
                        direction={'row'}
                        alignItems={'center'}
                        className="mt-[16px]"
                      >
                        <Stack flex={0.5}>
                          <FormTextField
                            outlineLabel={'LNG'}
                            name="bunkered.lng.mass"
                            onlyFloat={true}
                            // requiredMark={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>mt</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                        <Stack
                          flex={0.25}
                          className="mx-[16px]"
                        >
                          <FormTextField
                            outlineLabel={t('Volume')}
                            name="bunkered.lng.volume"
                            onlyFloat={true}
                            // requiredMark={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>m³</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                        <Stack flex={0.25}>
                          <FormTextField
                            outlineLabel={t('Density')}
                            name="bunkered.lng.density"
                            onlyFloat={true}
                            // requiredMark={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>kg/m³</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                      </Stack>
                      <Stack
                        direction={'row'}
                        alignItems={'center'}
                        className="mt-[16px]"
                      >
                        <Stack flex={0.5}>
                          <FormTextField
                            outlineLabel={t('Methanol')}
                            name="bunkered.methanol.mass"
                            onlyFloat={true}
                            // requiredMark={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>mt</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                        <Stack
                          flex={0.25}
                          className="mx-[16px]"
                        >
                          <FormTextField
                            outlineLabel={t('Volume')}
                            name="bunkered.methanol.volume"
                            onlyFloat={true}
                            // requiredMark={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>m³</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                        <Stack flex={0.25}>
                          <FormTextField
                            outlineLabel={t('Density')}
                            name="bunkered.methanol.density"
                            onlyFloat={true}
                            // requiredMark={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>kg/m³</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                      </Stack>
                      <Stack
                        direction={'row'}
                        alignItems={'center'}
                        className="mt-[16px]"
                      >
                        <Stack flex={0.5}>
                          <FormTextField
                            outlineLabel={t('Ethanol')}
                            name="bunkered.ethanol.mass"
                            onlyFloat={true}
                            // requiredMark={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>mt</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                        <Stack
                          flex={0.25}
                          className="mx-[16px]"
                        >
                          <FormTextField
                            outlineLabel={t('Volume')}
                            name="bunkered.ethanol.volume"
                            onlyFloat={true}
                            // requiredMark={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>m³</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                        <Stack flex={0.25}>
                          <FormTextField
                            outlineLabel={t('Density')}
                            name="bunkered.ethanol.density"
                            onlyFloat={true}
                            // requiredMark={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>kg/m³</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                      </Stack>
                      <Stack
                        direction={'row'}
                        alignItems={'center'}
                        className="mt-[16px]"
                      >
                        <Stack flex={0.5}>
                          <FormTextField
                            outlineLabel={t('Others')}
                            name="bunkered.others.mass"
                            onlyFloat={true}
                            // requiredMark={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>mt</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                        <Stack
                          flex={0.25}
                          className="mx-[16px]"
                        >
                          <FormTextField
                            outlineLabel={t('Volume')}
                            name="bunkered.others.volume"
                            onlyFloat={true}
                            // requiredMark={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>m³</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                        <Stack flex={0.25}>
                          <FormTextField
                            outlineLabel={t('Density')}
                            name="bunkered.others.density"
                            onlyFloat={true}
                            // requiredMark={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>kg/m³</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                      </Stack>
                    </Stack>
                    <Stack
                      style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', borderWidth: '1px', borderColor: '#8993AC26' }}
                      className="m-[15px] p-[16px]"
                    >
                      <Typography
                        className="fw-regular ff-Roboto fs-16"
                        color={text}
                      >
                        {t('Cargo')}
                      </Typography>
                      <Typography
                        className="fw-regular ff-Roboto fs-12 !mb-[16px]"
                        color={textLight}
                      >
                        {t('Some info may be visible to other people using ZeroEmission services')}
                      </Typography>
                      <Stack
                        direction={'row'}
                        alignItems={'center'}
                        flex={1}
                      >
                        <Stack flex={0.5}>
                          <FileUploadField
                            placeholder={t('Upload Bill of Loading')}
                            url={values?.cargo?.billOfLoading || null}
                            inputId={`doc1`}
                            handleFile={(files) => handleFile2(files)}
                            showFileName={true}
                            fileName={t('Cargo Bill of loading')}
                            bgColor={'#64717C3B'}
                            height={'56px'}
                          />
                        </Stack>
                      </Stack>
                      <Stack
                        direction={'row'}
                        alignItems={'center'}
                        flex={1}
                      >
                        <Stack
                          flex={0.5}
                          className="!mt-[8px]"
                        >
                          <FormTextField
                            outlineLabel={t('Cargo Carried')}
                            name="cargo.cargoCarried"
                            onlyFloat={true}
                            requiredMark={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>mt</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                        <Stack
                          flex={0.5}
                          className="!mt-[18px] ml-[10px]"
                        >
                          <FormSelectField
                            name="cargo.loadingCondition"
                            label={t('Ship condition') + ' *'}
                          >
                            {shipCondition?.length === 0 && (
                              <MenuItem
                                disabled
                                value=""
                              >
                                <em>{t('No Data Found')}</em>
                              </MenuItem>
                            )}
                            {shipCondition?.map((item) => (
                              <MenuItem
                                key={item.name}
                                value={item.name}
                              >
                                <div style={{ textTransform: 'capitalize' }}>{t(item.name)}</div>
                              </MenuItem>
                            ))}
                          </FormSelectField>
                        </Stack>
                      </Stack>
                    </Stack>
                    <Stack
                      style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', borderWidth: '1px', borderColor: '#8993AC26' }}
                      className="m-[15px] p-[16px]"
                    >
                      <Typography
                        className="fw-regular ff-Roboto fs-16 !capitalize"
                        color={text}
                      >
                        {t('Remaining onboard')}
                      </Typography>
                      <Typography
                        className="fw-regular ff-Roboto fs-12 !mb-[16px]"
                        color={textLight}
                      >
                        {t('Some info may be visible to other people using ZeroEmission services')}
                      </Typography>
                      <Stack
                        direction={'row'}
                        alignItems={'center'}
                        flex={1}
                      >
                        <Stack flex={0.5}>
                          <FormTextField
                            outlineLabel={'HFO'}
                            name="remaingOnBoard.hsfo"
                            onlyFloat={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>mt</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                        <Stack
                          flex={0.5}
                          className="ml-[10px]"
                        >
                          <FormTextField
                            outlineLabel={t('LPG butane')}
                            name="remaingOnBoard.lpgButane"
                            onlyFloat={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>mt</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                      </Stack>
                      <Stack
                        direction={'row'}
                        alignItems={'center'}
                        flex={1}
                        className="mt-[16px]"
                      >
                        <Stack flex={0.5}>
                          <FormTextField
                            outlineLabel={'MDO'}
                            name="remaingOnBoard.mdo"
                            onlyFloat={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>mt</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                        <Stack
                          flex={0.5}
                          className="ml-[10px]"
                        >
                          <FormTextField
                            outlineLabel={'LNG'}
                            name="remaingOnBoard.lng"
                            onlyFloat={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>mt</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                      </Stack>
                      <Stack
                        direction={'row'}
                        alignItems={'center'}
                        flex={1}
                        className="mt-[16px]"
                      >
                        <Stack flex={0.5}>
                          <FormTextField
                            outlineLabel={'MGO'}
                            name="remaingOnBoard.mgo"
                            onlyFloat={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>mt</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                        <Stack
                          flex={0.5}
                          className="ml-[10px]"
                        >
                          <FormTextField
                            outlineLabel={t('Methanol')}
                            name="remaingOnBoard.methanol"
                            onlyFloat={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>mt</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                      </Stack>
                      <Stack
                        direction={'row'}
                        alignItems={'center'}
                        flex={1}
                        className="mt-[16px]"
                      >
                        <Stack flex={0.5}>
                          <FormTextField
                            outlineLabel={'LFO'}
                            name="remaingOnBoard.lfo"
                            onlyFloat={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>mt</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                        <Stack
                          flex={0.5}
                          className="ml-[10px]"
                        >
                          <FormTextField
                            outlineLabel={t('Ethanol')}
                            name="remaingOnBoard.ethanol"
                            onlyFloat={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>mt</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                      </Stack>
                      <Stack
                        direction={'row'}
                        alignItems={'center'}
                        flex={1}
                        className="mt-[16px]"
                      >
                        <Stack flex={0.5}>
                          <FormTextField
                            outlineLabel={t('LPG propane')}
                            name="remaingOnBoard.lpgPropane"
                            onlyFloat={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>mt</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                        <Stack
                          flex={0.5}
                          className="ml-[10px]"
                        >
                          <FormTextField
                            outlineLabel={t('Others')}
                            name="remaingOnBoard.others"
                            onlyFloat={true}
                            whiteSpace={true}
                            inputProps={{ maxLength: 10 }}
                            sx={{ marginBottom: '10px' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography>mt</Typography>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                      </Stack>
                    </Stack>
                  </Stack>
                  <DialogActions
                    className="!mt-[44px] h-[66px] !justify-end p-[0px] sticky bottom-[0] !px-[250px]"
                    style={{ backgroundColor: '#FFFFFF', zIndex: 1 }}
                  >
                    <Button
                      sx={[
                        buttonStyle2,
                        {
                          color: theme.palette.background.main,
                          backgroundColor: theme.palette.primary.dark,
                          textTransform: 'uppercase',
                          '&:hover': {
                            // backgroundColor: theme.palette.secondary.main,
                            // color: theme.palette.background.main,
                          },
                        },
                      ]}
                      style={{ width: '128px', height: '40px' }}
                      disabled={!(dirty && isValid) || !monitoringDataCheck(values) || !distanceAndTimeCheck(values) || !voyageStateCheck(values) || !portCheck(values) || !distanceAndTimeCheck(values) || !cargoCheck(values) || !robCheck(values)}
                      type="submit"
                      variant="contained"
                    >
                      {t('Save')}
                    </Button>
                  </DialogActions>
                </Form>
              )}
            </Formik>
          </Stack>
        </Stack>
      )}
    </Dialog>
  );
}
